import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container, Row } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import Draggable from 'react-draggable';
import { HotTable } from '@handsontable/react';
import Handsontable from 'handsontable';
import Spinner from '../common/Spinner';
import Style from '../../class/Style';
import styled from 'styled-components';

/** Action **/
import { SubtitleContext } from '../../contexts/SubtitleContext';
import { Player } from 'video-react';

import { set_video_duration } from '../../actions/viewOperationActions';
import {
  setEditTableHeight,
  setCellClass,
  setReadonly,
  addTenRow,
  set_COLUMNS_TimecodeLock,
  show_hide_Shot_Change,
  setTableColWidth,
} from '../../actions/editTableActions';
import {
  get_versionData,
  jsonData_nolocal,
  setTSubType,
} from '../../actions/subtypeActions';
import {
  setIsShowFindAllViewReplace,
  setIsShowFindAllViewInput,
  setFindAndReplaceSentence,
} from '../../actions/transOperation_find_Actions';
import {
  showHideFrameList,
  updateFindFrameTargetData,
  updateFindFrameGapTargetData,
  updateShotChangeData,
  updateFindFrameCPSTargetData,
} from '../../actions/find/frameFindAction';
import {
  setPlayerEditingSRTData,
  setIsEditMode,
  AddTC_FRAME,
  AddDetialJsonData,
  MoveWordToFromNextRow,
  updateEditTableData,
} from '../../actions/transOperationActions';
import { showHidePositionList } from '../../actions/find/positionFindAction';

/** Utils **/
import TimeUtils from '../../helper/TimeUtils';
import StringUtils from '../../helper/StringUtils';
import SubTitleUtils from '../../helper/SubTitleUtils';
import ApiUtils from '../../helper/ApiUtils';
import ProjectUtils from '../../helper/ProjectUtils';
import DragHandleUtils from '../../helper/DragHandleUtils';
import ZeroTimeUtils from '../../helper/ZeroTimeUtils';
import ShotChangeUtils from '../../helper/ShotChangeUtils';

import VideoFrame from '../../helper/VideoFrame/VideoFrame';

import TopControl from '../video/TopControl';

import TimecodeView from '../common/TimecodeView';

// Obj Class
import DataObj from '../../class/DataObj';
import DataObjArray from '../../class/DataObjArray';
import { Button, Icon, Label } from 'semantic-ui-react';
import ArratDataUtils from '../../helper/ArratDataUtils';
import DWSlogo from '../../images/DWSlogo.png';
import DocumentUtils from '../../helper/DocumentUtils';

/** Popup
 * 彈出的內容物件
 * **/
import PopupGroupList from './PopupGroupList';

/** Find lis
 * 顯示結果
 * **/
import FindResultGroup from './FindResult/FindResultGroup';
import WaveGroup from './wave/WaveGroup';

import lockIcon from '../../images/icon/lockIcon.png';
import { HotkeysHook } from './HotkeysHook';
import IgnoreBtnView from '../common/IgnoreBtnView';
import CompleteView from '../popup/Complete/Complete_Popup';
import ExportView from '../import/ExportView';
import ExportViewWrap from '../import/ExportViewWrap';
import PopDragWrap from '../common/PopDragWrap';

const FormtitleLable = styled.div`
  margin-top: 5px;
  position: relative;
  text-align: center;
  width: ${(props) => props.width}px;
`;
const IconLable = styled.button`
  border-radius: 3px;
  text-align: center;
  padding: 1px 3px;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`;

const IconWrap = (props) => {
  return (
    <FormtitleLable width={props.width} className='d-inline '>
      <IconLable>{props.children}</IconLable>
    </FormtitleLable>
  );
};

const CaptionContainer = styled.div`
  text-align: ${(props) => props.textAlign};
  position: absolute;
  bottom: ${(props) => props.bottom};
  left: 0;
  right: 0;
  top: ${(props) => props.top};
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
  lineheight: 130%;
  letter-spacing: 1px;
  font-size: ${(props) => props.fontSize}pt;
`;

const UploadedFilesUrl = 'http://104.237.55.12/UploadedFiles/';
// const UploadedFilesUrl = 'https://subprpapp.azurewebsites.net/UploadedFiles/';
// const UploadedFilesUrl = 'http://www.thesubpro.com/UploadedFiles/';

class WaveformView extends Component {
  static projectSubType = 0;

  constructor(props) {
    super(props);

    this.StopTime = 0;
    this.time_displayRef = React.createRef();
    this.hotTableComponent = React.createRef();
    this.timecodeComponent = React.createRef();
    this.igonreComponent = React.createRef();
    this.subtitleViewComponent = React.createRef();
    this.waveform = React.createRef();
    this.captionTextRef = React.createRef();
    this.SaveBtn = React.createRef();
    this.TranslationsNavbar = React.createRef();

    //用戶所有的列表資料 可共用
    this.projectListData = []; // 列表
    this.projectData = {}; //專案
    this.projectDetial = {}; //專案資料
    this.video = {}; //影片資料

    //表格內容
    this.DataObjArray = new DataObjArray([]);

    //this.subTitle = React.createRef();//字幕

    /** 表單相關功能  */
    //使用者藍框
    this.timecode_row = 0; //確認移動到哪裡的藍匡
    this.blue_row = 0;
    this.blue_col = 0;
    //使用者的多選
    this.selectStart = 0;
    this.selectEnd = 0;
    this.selectStart_col = 0; //開始欄位
    this.selectEnd_col = 0; //結束欄位
    //滑鼠移動到的位置
    this.cellCoords_row = 0;
    this.cellCoords_col = 0;
    this.befoCellChangeData = [];
    this.findFrameSplitValue = this.props.context.findFrameSplitValue;
    //更新後端的工具
    this.isEdit = false; //有編輯的話要更新，等待下一個三十秒就是上傳
    this.countSeconds = 0; //秒數累計
    this.isEditing = false; //是否正在編輯
    this.beforeChangeData = [];
    this.savedData = []; //已經儲存過的檔案
    this.PasteEvent = []; //貼上事件

    /** 播放相關功能  */
    this.videoFps = 0;
    this.frameWidth = 0;
    this.playerVideo = null;
    this.videoCurrentTime_byDrag = 0; //拖拉而來的秒數
    this.videoCurrentTime_byCtrlRight = []; //ctrl 右 而來的秒數
    this.Last_videoCurrentTime = 0; //記錄上一次字幕的更新時間
    this.Last_currentDataIndex = 0; //播放的時候的最後一個row
    this.Last_SubtitleCaption = 0; //上一個字幕
    this.currentDataIndex = 0; //記錄當前的rowIndex
    this.isPlay = false;
    this.handleDragValue = 0;
    this.way = 0; //字幕位置
    this.textAlign = 'center';
    this.top = '';
    this.bottom = '40px';
    this.playerStopTime = 0; //用戶要停的時間
    this.totalPlayTime = '';
    this.forwardSeconds = 5; //移動秒數
    this.subtitles_Left = this.props.viewOperation.subtitles_Left;
    this.videoTargetTrack; //字幕軌道

    /** shotchange相關   */
    this.shotchangeData; //影片 shotchange資料
    this.shotchangePtsData; //影片 shotchangePts資料

    /** 拖拉相關功能  */
    //handleDragValue:0, //拖拉數值
    this.DragData = [];
    this.isSetDuration = false; //設定影片總長度的flag

    this.frontDistance = 0; //waveform 的left位置

    /** 選單相關功能  */
    this.isShowTranslationsNavbar = false;
    this.lineNum = 0; //跳轉行數用

    this.fram = null; //輸入時間跳轉用
    this.seconds = null;
    this.Minute = null;
    this.hour = null;

    //本地用編輯資料
    this.LocalEditTableData = [];

    //錯誤
    this.frameSpliteErrorArray = []; //In Out
    this.TargetErrorArray = []; //Target
    this.frameSplitErrorCheckValue = 2; //手動檢查Error

    /** 拖拉所需  */
    this.popups = [];
    // this.popups_drag = [];
    this.pos1 = 0;
    this.pos2 = 0;
    this.pos3 = 0;
    this.pos4 = 0;
    this.elmnt_drag = null;
    this.currentZIndex = 100;

    this.popups_index = 0;
    this.frontDistance = 0;
    this.element = null;

    //判斷方向
    this.userWantRight = 0;
    this.userWantLeft = 0;
    this.orgLeft = 0;
    this.startX = 0;
    this.startY = 0;
    this.startWidth = 0;
    this.startHeight = 0;
    this.dragDirection = ''; //拖拉方向

    /**
     * 檢察Style相關
     * */
    this.isEnableStyleCheck = true; //是否開啟Style檢查功能
    this.StyleData = this.props.StyleData; //Style資料

    /**
     * 影片控制器
     * */
    this.videoFrame = null;

    this.state = {
      /**　資料處理 */
      loading: false,
      loadInitData: false,
      uploadTableData_loading: false,

      /** 播放相關功能  */
      duration: 0, //影片長度
      viewWidth: this.props.viewOperation.viewWidth, //影片顯示寬度
      viewHeight: this.props.viewOperation.viewHeight,
      ccEnable: true,
      subTitle: '',
      isBigFont: false,
      subPlayerSubtitle: [], //影片字幕

      /** 拖拉相關功能  */
      DragData: [],
      balloonView_left: 0,
      activeDrags: 0,
      deltaPosition: {
        x: 0,
        y: 0,
      },
      controlledPosition: {
        x: -400,
        y: 200,
      },

      /** 表單相關功能  */
      data: this.props.editTable.data,
      tableHeight: 0,
      isShowSource: false,

      /** 播放相關功能  */
      //ifShowPlayIcon:false, //雙擊的index,
      videoDuration: 0,
      CaptionContainerFontSize: 11,
      // SubtitleData:[], //字幕

      /** 選單  */
      isShowTranslationsNavbarAlert: false,
      collapsed: false,

      /** 搜尋功能  */
      isShowFindAllViewInput: false,
      isShowFindAllViewList: false,
      isShowFindPositionList: false,
      FindAllList: [], //Find所有
      FindReplaceTargetIndex: 0, //FindReplace 對象
      FindReplaceArray: [], //FindReplace 資料
      isShowExportErrorList: false, //輸出的列表

      /** 完成提是*/
      isShowComplete: false,
      message: '',

      /** 輸出畫面*/
      isShowExportView: false,
      isShowImportView: false,

      /**
       * 選單功能的彈跳
       * */
      isShowTimecodeShiftView: false,
      isShowVersionsView: false,
      isShowRunZerotime: false,
      isShowTimeLineAlert: false,
      isShowFindAllViewReplace: false,
      isShowMultipleFindReplace: false,
      isPositionAlignDialog: false,
      isShowFindFrameList: false,
      isShowFrameGapError: false,
      isShowAdjustFrameGapError: false,
      isShowFrameCPSError: false,
      isShowFindFrameGapList: false,
      isShowFindFrameCPSList: false,

      isShowShotChangeList: false, //

      /**
       * Input Latency相關
       * */
      isInputLatencyAct: false, //是否開啟
      inputLatencyFrameNum: false, // frame數量
    };

    this.popDoubleClick = this.popDoubleClick.bind(this);

    //設定拖拉
    this.handleDrag = this.handleDrag.bind(this);
    this.setDragHandleDragValue_byIndex =
      this.setDragHandleDragValue_byIndex.bind(this);

    //影片功能
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.ITManPlayer_play = this.ITManPlayer_play.bind(this);
    //this.updateSubTitle = this.updateSubTitle.bind(this);
    this.updateSubTitle_by_row_frame =
      this.updateSubTitle_by_row_frame.bind(this);
    this.subMove = this.subMove.bind(this); //抬字幕位置
    this.subMove_justMove = this.subMove_justMove.bind(this); //抬字幕位置
    this.initWaveSubAndDragData = this.initWaveSubAndDragData.bind(this);
    this.insertSymblo = this.insertSymblo.bind(this);
    this.changePlaybackRateRate = this.changePlaybackRateRate.bind(this);
    this.changeCurrentTime = this.changeCurrentTime.bind(this);
    this.ifShowPlayIcon = this.ifShowPlayIcon.bind(this);
    this.updatefindFrameSplitValue = this.updatefindFrameSplitValue.bind(this);
    this.updateforwardSeconds = this.updateforwardSeconds.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);

    //表格功能
    this.cutTC = this.cutTC.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.chevronEvent = this.chevronEvent.bind(this);
    this.saveLastData = this.saveLastData.bind(this);
    this.moveCellSelect = this.moveCellSelect.bind(this);
    this.arrowUpOrDown = this.arrowUpOrDown.bind(this);
    this.decorativeLettering = this.decorativeLettering.bind(this);
    this.decorativeMusic = this.decorativeMusic.bind(this);
    this.Jump_Backward_Forward = this.Jump_Backward_Forward.bind(this);
    this.setFindAllSelectRowCol = this.setFindAllSelectRowCol.bind(this);
    this.DragSubtitleWidth = this.DragSubtitleWidth.bind(this);
    this.checkFrameSplitErrorArray = this.checkFrameSplitErrorArray.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.updateInstanceTable_by_Row =
      this.updateInstanceTable_by_Row.bind(this);
    this.add_Row_from_ctrl_i = this.add_Row_from_ctrl_i.bind(this); //插入資料
    this.add_Row_from_click = this.add_Row_from_click.bind(this); //插入資料
    this.delete_Row = this.delete_Row.bind(this); //刪除
    this.mutile_delete_Row = this.mutile_delete_Row.bind(this); //刪除多個
    this.resize_full = this.resize_full.bind(this);
    this.resize_small = this.resize_small.bind(this);
    this.tableRunTargetCheck = this.tableRunTargetCheck.bind(this);

    //浮動
    this.timecode_stopClick = this.timecode_stopClick.bind(this);

    //表格渲染
    this.normalRowRenderer = this.normalRowRenderer.bind(this);
    this.findOneLineRowRenderer = this.findOneLineRowRenderer.bind(this);
    this.mixRowRenderer = this.mixRowRenderer.bind(this);
    this.errorRowRenderer = this.errorRowRenderer.bind(this);

    //儲存api
    this.saveData_update_EditTable_ITManPlayer_WaveGroup =
      this.saveData_update_EditTable_ITManPlayer_WaveGroup.bind(this);
    this.uploadTableData = this.uploadTableData.bind(this); //進DB

    //通用功能
    this.setIsEdit = this.setIsEdit.bind(this);

    //選單
    this.isShowTranslationsNavbarAlert =
      this.isShowTranslationsNavbarAlert.bind(this);
    this.send_Complete = this.send_Complete.bind(this);
    this.send_deleteSource = this.send_deleteSource.bind(this);
    this.activeTimecodeshift = this.activeTimecodeshift.bind(this);
    this.editTransaction = this.editTransaction.bind(this);
    this.handleReplace = this.handleReplace.bind(this);
    this.searchFrameError = this.searchFrameError.bind(this); //搜尋錯誤
    this.searchFrameError_Manual = this.searchFrameError_Manual.bind(this); //搜尋錯誤 手動版本 使用 frameSplitErrorCheckValue

    //影片下方列表
    this.setIsShowFindAllViewInput = this.setIsShowFindAllViewInput.bind(this);

    //拖拉相關
    this.initDragElement = this.initDragElement.bind(this);
    this.updateDragElement = this.updateDragElement.bind(this);
    this.elementDrag = this.elementDrag.bind(this);
    this.dragMouseDown = this.dragMouseDown.bind(this);
    this.closeDragElement = this.closeDragElement.bind(this);

    //左右
    this.initResizeElement = this.initResizeElement.bind(this);
    this.initDrag = this.initDrag.bind(this);
    this.doDrag = this.doDrag.bind(this);
    this.stopDrag = this.stopDrag.bind(this);
    //更新
    this.UpdateSpecificGraySquare_Size =
      this.UpdateSpecificGraySquare_Size.bind(this);
    this.UpdateSpecificGraySquare_text =
      this.UpdateSpecificGraySquare_text.bind(this);
  }

  /**
   * 類別本身 ==========================================
   * */
  async componentDidMount() {
    this.props.onRef(this);
    this.updateWindowDimensions();

    // 時間計算總類
    WaveformView.projectSubType = this.props.tSubType;

    await this.setState({ loadInitData: true });

    const {
      videoDuration,
      videoFps,
      frameWidth,
      findFrameSplitValue,
      tSubType,
    } = this.props;
    this.setState({ videoDuration, videoFps, frameWidth, findFrameSplitValue });

    //用戶基本資料
    const { user } = this.props.auth;
    const email = user['email'];

    // 舊的方式
    // 上網取得projectListData
    // if (email.includes('thesubpro.com') === true) {
    //   this.projectListData = await ProjectUtils.sentGetAllProjectDetial(
    //     user['unique_name']
    //   );
    //   localStorage.getItem('projectListData', JSON.stringify(projectListData));
    // } else {
    //   this.projectListData = await ProjectUtils.sentGetProjectDetial(
    //     user['unique_name']
    //   );
    // }

    //取得本地資料
    const projectListDataString = localStorage.getItem('projectListData');
    this.projectListData = JSON.parse(projectListDataString);

    //取得上層資料
    //projectDetial
    //確認資料index 跟專案資料
    this.projectIndex = parseInt(this.props.match.params.tIndex, 10);
    const projectData = this.projectListData[this.projectIndex]; //取得專案資料
    this.projectData = projectData;
    this.projectDetial = projectData.projectDetial; //本頁專案

    //取得Video資料
    this.video = projectData.video;
    // DurationVal: "00:23:29.0700000                                            "
    // FrameRateVal: 25
    // HeightVal: 720
    // InputSizeVal: 77567240
    // NameVal: null
    // OutputSizeVal: null
    // SizeVal: null
    // StartTime: 0
    // WaveImage: "NetflixFinalProxy_1946360_81478291_BoBoiBoy_Galaxy_Season_1_Episode_23.png                                                                                                                                                                                                                                                                                                                                      "
    // WidthVal: 1280
    // allDownloadUris: null
    // days: 7
    // downloadUris: null
    // fId: 475
    // fMeatdata: null
    // fProjectId: 0
    // fURL: "NetflixFinalProxy_1946360_81478291_BoBoiBoy_Galaxy_Season_1_Episode_23.mp4"
    // fVideoName: "NetflixFinalProxy_1946360_81478291_BoBoiBoy_Galaxy_Season_1_Episode_23.mp4"
    // hlsUri: null
    // inputAssetId: "                                                                                "
    // mpegDashUri: null
    // outputAssetId: null
    // seconds: 1409.088
    // smoothStreamingUri: null
    //const { videoDuration, videoFps, frameWidth, findFrameSplitValue } = this.props;
    //const { frameWidth} = this.props.transOperation;
    this.setState({
      videoDuration: 0,
      videoFps: this.video.FrameRateVal,
      frameWidth: frameWidth,
      findFrameSplitValue: SubTitleUtils.get_findFrameSplitValue_from_local(),
    });
    this.videoFps = this.video.FrameRateVal;
    this.frameWidth = frameWidth;
    this.frameSplitErrorCheckValue =
      SubTitleUtils.get_findFrameSplitValue_from_local();

    //更新version
    await this.props.get_versionData(this.projectDetial.fId);

    //先設定 this.props.editTable 裡面的 data
    /**
     * 取專案資料
     * */
    const jsonData = await this.props.jsonData_nolocal(
      parseFloat(this.videoFps),
      this.projectDetial.fId,
      email
    );
    await this.props.updateEditTableData(jsonData);

    //設定表格資料
    this.props.setCellClass(this.props.editTable.data);

    //本地資料
    this.LocalEditTableData = this.props.editTable.data;

    //確認frame間隔
    this.findFrameSplitValue = parseFloat(
      this.props.context.findFrameSplitValue
    );

    //如果是完成狀態 要關閉表單
    if (this.projectDetial.status === 2) {
    }

    //狀態如果是編輯中：自動儲存開始
    // //時間
    //
    this.interval = setInterval(async () => {
      if (this.isEdit === true && this.countSeconds === 30) {
        //console.log(`儲存 isEdit ${this.isEdit} countSeconds ${this.countSeconds}`);

        //檢察檔案有沒有調整過
        if (
          ArratDataUtils.checkIsEquire(
            this.savedData,
            this.DataObjArray.getContent()
          ) === true
        ) {
          //console.log(`檢察檔案 沒有調整過`);
          this.setIsEdit(false);
          this.countSeconds = 0;
          return;
        }

        //上傳文件
        this.uploadTableData();
      } else {
        this.countSeconds += 5;
      }

      if (this.countSeconds > 30) {
        this.countSeconds = 0;
      }
    }, 5000);

    /** 確認表單是否可以操作*/
    if (parseInt(this.props.match.params.tType, 10) === 0) {
      this.setState({ isEditMode: false });
      this.props.setReadonly(true);
    } else if (parseInt(this.props.match.params.tType, 10) === 1) {
      this.setState({ isEditMode: true });
      this.props.setReadonly(false);
    }

    /**
     * 新增十個空白欄位
     * */
    await this.props.addTenRow(this.props.editTable.data);

    this.DataObjArray.setArray(this.props.editTable.data); //初始資料
    this.DataObjArray.checkInAndOutAtBegin(); //檢查

    //let track = document.createElement("track");
    //let track = this.player.video.video.addTextTrack("captions", "English", "en",);

    // Get all text tracks for the current player.
    //         var myPlayer = videojs('video-id');
    //         var oldTracks = this.player.remoteTextTracks();
    //         console.log('設定字幕 subPlayerSubtitle');
    //         this.player.addTextTrack('captions', 'En', 'English');

    //關閉預設快結鍵
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
        e.preventDefault();
      }
    });

    /**
     * 取得Input Latency狀態
     * */

    if (!localStorage.isInputLatencyAct) {
      //初始
      localStorage.setItem('isInputLatencyAct', false);
      localStorage.setItem('inputLatencyFrameNum', 0);
    } else {
      const isInputLatencyAct = localStorage.getItem('isInputLatencyAct');
      const inputLatencyFrameNum = localStorage.getItem('inputLatencyFrameNum');
      this.setState({ isInputLatencyAct: JSON.parse(isInputLatencyAct) });
      this.setState({ inputLatencyFrameNum: parseFloat(inputLatencyFrameNum) });
    }

    /**
     * 給定影片控制器
     * */
    this.videoFrame = new VideoFrame({
      //id : 'videoPlayer',
      element: '.video-react-video',
      frameRate: this.video.FrameRateVal,
      callback: function (response) {
        console.log('callback response: ' + response);
      },
    });

    /***
     * 取得 window.EditingProjectInfo
     */
    const ProjectInfo = ProjectUtils.getEditingProjectInfo(
      this.projectListData
    );
    const listView = ProjectInfo['listView'];
    const fProjectId = parseFloat(this.projectDetial['fProjectId']);
    const result = listView.filter(
      (row) => parseFloat(row.Project.fId) === fProjectId
    );
    window.EditingProjectInfo = JSON.stringify(result[0]);

    /**
     * 取得Project style 資料
     * */
    const StyleData = await SubTitleUtils.get_detialStyle();
    let newStyleData = new Style(StyleData);
    this.StyleData = newStyleData;

    //影片字幕大小
    this.CaptionContainerFontSize = this.StyleData.fFontSize;

    await this.setState({ loadInitData: false });

    /***
     * =================== 資料準備結束 開始處理介面
     */

    //綁定撥放器的狀態
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));

    /**
     * 設定Style
     * */
    this.DataObjArray.setStyle(this.StyleData);
    //初始Style檢查
    this.tableRunTargetCheck();

    //初始拖拉資料
    this.initWaveSubAndDragData();

    setTimeout(
      function () {
        //Start the timer
        // this.initDragElement();
        // this.initResizeElement();
        this.popups = document.getElementsByClassName('popup');
      }.bind(this),
      1000
    );

    /**
     * 設定字幕 subPlayerSubtitle
     * */
    // const newsubPlayerSubtitle = SubTitleUtils.getExport_VTT_DataObject(this.props.editTable.data);
    // this.setState({subPlayerSubtitle:newsubPlayerSubtitle});
    SubTitleUtils.initTrack(this);

    /**
     * 確認TC有沒有鎖定 columns isTimecodeLock設定的話就不能拖拉
     * */
    if (parseFloat(this.projectDetial.isTimecodeLock) === 1) {
      this.props.set_COLUMNS_TimecodeLock(this.props.editTable.columns);
    }

    /**
     * 取的ShotChange資料與 ShotChangePTS
     * */
    // console.log(this.video.downloadUris);
    await ShotChangeUtils.runShotChange(this.video.downloadUris, this);

    await this.setState({ loadInitData: false });

    // TODO: 測試為主
    this.props.updateShotChangeData(
      this.DataObjArray.getContent(),
      this.shotchangeData
    );
  }
  /**
   * 拖拉
   * */
  initDragElement() {
    this.popups = document.getElementsByClassName('popup');

    for (var i = 0; i < this.popups.length; i++) {
      var popup = this.popups[i];
      popup.id = `popup_${i}`;

      const targetData = this.DataObjArray.getObj(i);
      //尺寸
      popup.style.left = targetData.getDragEleLeft() + 'px';
      popup.style.width = targetData.getDragEleWidth() + 'px';

      var header = getHeader(popup);

      popup.onmousedown = function () {
        this.style.zIndex = '' + ++this.currentZIndex;
      };

      if (header) {
        header.text = targetData.Subscription;

        header.parentPopup = popup;
        header.onmousedown = this.dragMouseDown;

        const dataObj = this.DataObjArray.getObj(i);
        if (dataObj.SubtitleCaption) {
          header.innerText = dataObj.SubtitleCaption;
        }
      }
    }

    function getHeader(element) {
      var headerItems = element.getElementsByClassName('popup-header');
      // popup-header

      if (headerItems.length === 1) {
        return headerItems[0];
      }

      return null;
    }
  }

  //更新拖拉物件
  updateDragElement() {
    this.popups = document.getElementsByClassName('popup');

    for (var i = 0; i < this.popups.length; i++) {
      var popup = this.popups[i];
      popup.id = `popup_${i}`;

      const targetData = this.DataObjArray.getObj(i);

      //尺寸
      popup.style.left = targetData.getDragEleLeft() + 'px';
      popup.style.width = targetData.getDragEleWidth() + 'px';

      var header = getHeader(popup);

      popup.onmousedown = function () {
        this.style.zIndex = '' + ++this.currentZIndex;
      };

      if (header) {
        header.text = targetData.Subscription;

        header.parentPopup = popup;
        header.onmousedown = this.dragMouseDown;

        const dataObj = this.DataObjArray.getObj(i);
        if (dataObj.SubtitleCaption) {
          header.innerText = dataObj.SubtitleCaption;
        }
      }
    }

    function getHeader(element) {
      var headerItems = element.getElementsByClassName('popup-header');
      // popup-header

      if (headerItems.length === 1) {
        return headerItems[0];
      }

      return null;
    }
  }

  elementDrag(e) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    if (!this.elmnt_drag) {
      return;
    }

    e = e || window.event;
    // calculate the new cursor position:
    this.pos1 = this.pos3 - e.clientX;
    // pos2 = pos4 - e.clientY;
    this.pos3 = e.clientX;
    // pos4 = e.clientY;
    // set the element's new position:
    // elmnt.style.top = elmnt.offsetTop - pos2 + "px";
    this.elmnt_drag.style.left = this.elmnt_drag.offsetLeft - this.pos1 + 'px';
  }
  dragMouseDown(e) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    this.elmnt_drag = ReactDOM.findDOMNode(e.currentTarget).parentNode;
    this.elmnt_drag.style.zIndex = '' + ++this.currentZIndex;

    e = e || window.event;
    // get the mouse cursor position at startup:
    this.pos3 = e.clientX;

    // pos4 = e.clientY;
    //document.onmouseup = DragHandleUtils.closeDragElement(this);
    document.onmouseup = this.closeDragElement;

    // call a function whenever the cursor moves:
    document.onmousemove = this.elementDrag;
  }
  closeDragElement(e) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    this.popups_index = parseFloat(
      `${this.elmnt_drag.id}`.replace('popup_', '')
    );

    //const frameWidth = 2.76;
    const frontDistance = 0;

    //當前物件
    let newData = this.DataObjArray.getContent();
    let currentDataObj = new DataObj(newData[this.popups_index]);
    currentDataObj.setTSubType(WaveformView.projectSubType);

    this.userWantLeft = parseFloat(
      `${this.elmnt_drag.style.left}`.replace('px', '')
    );
    const width = currentDataObj.getDragEleWidth();

    /* stop moving when mouse button is released:*/
    document.onmouseup = null;
    document.onmousemove = null;

    // console.log(e);
    // console.log(this.elmnt_drag);

    //新的秒數
    const newStartSecond = (this.userWantLeft - frontDistance) / 40;

    //結束的秒數
    const newEndSecond = (this.userWantLeft - frontDistance + width) / 40;

    // const In = TimeUtils.convertSecondToTimeString(newStartSecond,videoFps);
    // const Out = TimeUtils.convertSecondToTimeString(newEndSecond,videoFps);

    let distance = Math.abs(
      parseFloat(newStartSecond).toFixed(2) -
        parseFloat(currentDataObj.start).toFixed(2)
    );
    const frame2 = (2 * 1) / parseFloat(this.videoFps);

    // console.log(`時間剪雜查 ${distance.toFixed(2) } / ${frame2} --  ${parseFloat(newStartSecond).toFixed(2)} ${parseFloat(currentDataObj.start).toFixed(2)}`);

    if (parseFloat(distance.toFixed(2)) < frame2) {
      //相同 沒有移動
    } else {
      //console.log(`時間剪雜查 ${parseFloat(newStartSecond).toFixed(2)} ${parseFloat(currentDataObj.start).toFixed(2)}`);

      //更新表格　拖拉
      currentDataObj.setInOut('In', newStartSecond);
      currentDataObj.setInOut('Out', newEndSecond);

      newData[this.popups_index] = currentDataObj;
      this.DataObjArray.updateDataObj_by_index(
        this.popups_index,
        currentDataObj
      );

      //更新表格時間
      this.hotTableComponent.current.hotInstance.setDataAtRowProp(
        parseInt(this.popups_index, 10),
        'In',
        currentDataObj.In
      );
      this.hotTableComponent.current.hotInstance.setDataAtRowProp(
        parseInt(this.popups_index, 10),
        'Out',
        currentDataObj.Out
      );

      //this.sendsetTableData(newData);

      //有編輯
      this.setIsEdit(true);

      //更新當前影片字幕
      this.updateSubTitle_by_row_frame(this.popups_index);
    }
  }

  /**
   * 左右尺吋
   * */
  initResizeElement() {
    this.popups = document.getElementsByClassName('popup');
    this.popups_index = 0;
    this.frontDistance = 0;
    this.element = null;

    for (var i = 0; i < this.popups.length; i++) {
      var p = this.popups[i];
      p.id = `popup_${i}`;

      ReactDOM.findDOMNode(p).addEventListener('dblclick', this.popDoubleClick);

      var left = document.createElement('div');
      left.className = 'resizer-left';
      p.appendChild(left);
      left.addEventListener('mousedown', this.initDrag, false);
      left.parentPopup = p;

      var right = document.createElement('div');
      right.className = 'resizer-right';
      p.appendChild(right);
      right.addEventListener('mousedown', this.initDrag, false);
      right.parentPopup = p;

      var bottom = document.createElement('div');
      bottom.className = 'resizer-bottom';
      p.appendChild(bottom);
      bottom.addEventListener('mousedown', this.initDrag, false);
      bottom.parentPopup = p;

      var both = document.createElement('div');
      both.className = 'resizer-both';
      p.appendChild(both);
      both.addEventListener('mousedown', this.initDrag, false);
      both.parentPopup = p;
    }
  }

  initDrag(e) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    this.element = ReactDOM.findDOMNode(e.currentTarget).parentNode;
    // this.element = this.parentPopup;

    // console.log(e);
    // console.log(e.currentTarget);
    // console.log(this.element );
    // console.log(e.currentTarget.className );
    // console.log(`--------------`);

    //確定是頭還是尾
    this.dragDirection = `${e.currentTarget.className}`.replace('resizer-', '');

    //調整結束時間
    this.orgLeft = parseFloat(this.element.style.left);
    this.startX = e.clientX;
    //this.startX = this.element.style.left;
    this.startY = e.clientY;
    this.startWidth = parseInt(
      document.defaultView.getComputedStyle(this.element).width,
      10
    );

    this.startHeight = parseInt(
      document.defaultView.getComputedStyle(this.element).height,
      10
    );

    document.documentElement.addEventListener('mousemove', this.doDrag, false);
    document.documentElement.addEventListener('mouseup', this.stopDrag, false);
  }

  doDrag(e) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    // console.log(`/--------------------------------------`);
    // console.log(e);

    let dragDistance = this.startX - e.clientX;

    // console.log(`doDrag this.startX ${ this.startX} e.clientX ${e.clientX}  `);
    //    console.log(`dragDistance: ${dragDistance}px`);
    //   console.log(`this.orgLeft: ${this.orgLeft}`);

    if (this.dragDirection === 'left') {
      //調整起始時間
      //
      this.element.style.left = this.orgLeft - dragDistance + 'px';
      this.element.style.width = this.startWidth + dragDistance + 'px';

      // console.log(`left width: ${this.element.style.left}/${this.element.style.width }`);
    } else {
      //結束時間
      this.element.style.width =
        this.startWidth + e.clientX - this.startX + 'px';
    }
    // element.style.height = startHeight + e.clientY - startY + "px";
  }

  stopDrag() {
    DragHandleUtils.stopDrag_move(this);

    //更新字幕
    this.updateSubTitle_by_row_frame(this.popups_index);

    this.setIsEdit(true);
    this.element.removeEventListener('mousemove', this.doDrag, false);
    this.element.removeEventListener('mouseup', this.stopDrag, false);

    document.documentElement.removeEventListener(
      'mousemove',
      this.doDrag,
      false
    );
    document.documentElement.removeEventListener(
      'mouseup',
      this.stopDrag,
      false
    );
  }

  //更新拖拉塊
  UpdateSpecificGraySquare_Size(RowIndex) {
    const dataObj = this.DataObjArray.getObj(RowIndex);
    let element = this.popups[RowIndex];
    DocumentUtils.ChangeGraySquareSize(element, dataObj);
  }
  UpdateSpecificGraySquare_text(RowIndex) {
    const dataObj = this.DataObjArray.getObj(RowIndex);
    let element = this.popups[RowIndex];
    DocumentUtils.UpdateSpecificGraySquare_text(element, dataObj);
  }

  /**
   * 選單
   * */
  //顯示漢堡選單
  isShowTranslationsNavbarAlert(result) {
    this.setState({ isShowTranslationsNavbarAlert: result });
  }

  /**
   * 發送成功訊息
   * */
  async send_Complete() {
    //檢查有沒有下一步
    const nextStepResult = await ApiUtils.get_sql(
      `${ApiUtils.post_CheckIsHaveNext}?tProjectDetialId=${this.projectDetial.fId}`
    );

    //直行完成下一步驟
    await ApiUtils.get_sql(
      `${ApiUtils.get_CompleteStep}?tProjectDetialId=${this.projectDetial.fId}`
    );

    this.props.history.push('/Home');

    window.location.reload();
  }
  async send_deleteSource() {
    await this.setState({ isShowComplete: false });

    const newDataObjArray = await this.props.deleteSource(
      this.DataObjArray.getContent()
    );
    this.DataObjArray.setArray(newDataObjArray);

    const { user } = this.props.auth;
    const email = user['email'];

    //儲存
    await this.props.AddDetialJsonData({
      tProjectDetialId: this.projectDetial.fId,
      jsonstring: this.DataObjArray.getContent(),
      email: email,
    });
  }

  activeTimecodeshift(
    videoFps,
    findFrameSplitValue,
    distance,
    firstDataIndex,
    lastDataIndex
  ) {
    let stringData = this.DataObjArray.getContent();

    stringData.map((request, index) => {
      if (index >= firstDataIndex && index <= lastDataIndex) {
        let currentObj = this.DataObjArray.getObj(index);

        if (currentObj.In !== '' && currentObj.Out !== '') {
          let beginFrameNumber = TimeUtils.timeString_convertTo_frame(
            currentObj.In
          );
          let endFrameNumber = TimeUtils.timeString_convertTo_frame(
            currentObj.Out
          );

          beginFrameNumber += parseFloat(distance);
          endFrameNumber += parseFloat(distance);

          //get frame number
          let durationFrame =
            parseFloat(endFrameNumber) - parseFloat(beginFrameNumber);
          // let duration = TimeUtils.getTimeStringFrom_FrameCount(durationFrame);

          let start = TimeUtils.getTimeStringFrom_FrameCount(
            beginFrameNumber,
            TimeUtils.getFPS()
          );
          let end = TimeUtils.getTimeStringFrom_FrameCount(
            endFrameNumber,
            TimeUtils.getFPS()
          );

          currentObj.setInOut('In', start);
          currentObj.setInOut('Out', end);

          this.DataObjArray.updateDataObj_by_index(index, currentObj);
        }
      }
    });

    //初始字幕跟拖拉資料
    this.saveData_update_EditTable_ITManPlayer_WaveGroup(
      this.DataObjArray.getContent()
    );
    this.setIsEdit(true);
  }

  //透過時間移動到該物件
  editTransaction() {
    const { videoFps } = this.props.transOperation;

    const data = this.DataObjArray.getContent();

    let hour, Minute, seconds, fram;

    if (this.fram === null) {
      fram = 0;
    } else {
      fram = this.fram > videoFps ? videoFps : this.state.fram;
    }

    if (this.second === null) {
      seconds = 0;
    } else {
      seconds = this.second * videoFps;
    }

    if (this.Minute === null) {
      Minute = 0;
    } else {
      Minute = this.Minute * 60 * videoFps;
    }

    if (this.hour === null) {
      hour = 0;
    } else {
      hour = this.hour * 60 * 60 * videoFps;
    }

    this.fram = null;
    this.seconds = null;
    this.Minute = null;
    this.hour = null;

    let wnat_frame =
      parseFloat(fram) +
      parseFloat(seconds) +
      parseFloat(Minute) +
      parseFloat(hour);
    let startSecond = wnat_frame / videoFps;
    let lineNum = TimeUtils.secondsConvertToRowIndew(
      startSecond,
      videoFps,
      data
    );

    //灰框點擊兩下
    DragHandleUtils.setDoubleClick(this, lineNum);
  }

  //交換文字
  //執行更新 0:只更新當前的

  /**
   * @param type  0:只更新當前的　1:更新全部
   */
  async handleReplace(type, user) {
    const data = this.DataObjArray.getContent();
    // （
    if (user.findString !== null) {
      //更新 調整全形問題
      let targetTitle = this.props.transOperation.findAndReplaceSentence; //
      //var re = new RegExp(user.findString, "g");
      //var re = /user.findString/g;
      // var newTitle =  targetTitle.replace(re,user.wantReplaceString);

      // if(targetTitle==''){
      //   return;
      // }

      var newTitle = targetTitle.replaceAll(
        user.findString,
        user.wantReplaceString === null ? '' : user.wantReplaceString
      );

      if (type === 0) {
        //只換一次
        //位置
        let location = this.props.transOperation.findAndReplaceSelectRowCol;

        //更新
        const rowIndex = location[0];

        //更新資料
        let placeData = new DataObj(data[rowIndex]);
        placeData.setTSubType(WaveformView.projectSubType);
        placeData.setSubtitleCaption(newTitle);
        data[rowIndex] = placeData;
        this.DataObjArray.setArray(data);

        //介面更新
        this.UpdateSpecificGraySquare_Size(rowIndex);
        this.updateInstanceTable_by_Row(rowIndex);

        this.setIsEdit(true);
      } else if (type === 1) {
        let newData = data;

        let firstIndex = null;

        data.forEach(function (obj, index) {
          let checkObj = new DataObj(obj);
          checkObj.setTSubType(WaveformView.projectSubType);

          let rowSubtitle = checkObj.SubtitleCaption;

          var n = rowSubtitle.includes(user.findString);

          if (user.isCaseSensitivity === false) {
            n = rowSubtitle
              .toLowerCase()
              .includes(user.findString.toLowerCase());
          }

          if (n === true) {
            if (firstIndex === null) {
              firstIndex = index;
            }

            //調整全形問題
            //var re = new RegExp(user.findString, "g");
            //var newTitle =  rowSubtitle.replace(re,user.wantReplaceString);
            //var newTitle =  rowSubtitle.replace(user.findString,user.wantReplaceString);
            var newTitle = '';

            if (user.isCaseSensitivity === false) {
              // 不分大小寫
              // var re = new RegExp(user.findString, 'gi');

              // var rule = "/" + user.findString + "/gi"  ;

              // TODO: 處理問號問題
              // if(user.findString.includes('?')){

              //   var re = new RegExp(user.findString.replace("?", "\\?"), "gi");

              //   newTitle = rowSubtitle.replace(re, user.wantReplaceString);
              // }else{
              //   newTitle = rowSubtitle.replaceAll(
              //     user.findString,
              //     user.wantReplaceString === null ? "" : user.wantReplaceString
              //   );
              // }

              newTitle = rowSubtitle.replaceAll(
                user.findString,
                user.wantReplaceString === null ? '' : user.wantReplaceString
              );
            } else {
              // 區分大小寫
              newTitle = rowSubtitle.replaceAll(
                user.findString,
                user.wantReplaceString === null ? '' : user.wantReplaceString
              );
            }

            checkObj.setSubtitleCaption(newTitle);
            newData[index] = checkObj;
          }
        });

        if (firstIndex !== null) {
          //重載文字 //初始字幕跟拖拉資料
          this.saveData_update_EditTable_ITManPlayer_WaveGroup(newData);

          //更新搜尋的顯示文字
          this.props.setFindAndReplaceSentence(
            newData[firstIndex].SubtitleCaption
          );

          this.setIsEdit(true);
        }
      }
    }
  }

  //搜尋錯誤影格
  searchFrameError() {
    //開始搜尋
    this.props.updateFindFrameTargetData(
      this.DataObjArray.getContent(),
      this.videoFps,
      this.StyleData.fFrameSplit
    );
  }

  //手動搜尋錯誤影格
  searchFrameError_Manual() {
    //開始搜尋
    this.props.updateFindFrameTargetData(
      this.DataObjArray.getContent(),
      this.videoFps,
      this.frameSplitErrorCheckValue
    );
  }

  afterFindReplaceChange = (playerEditingData, changeArray) => (dispatch) => {
    const rowIndex = changeArray[0];
    const key = changeArray[1];

    let newplayerEditingData = playerEditingData;

    // console.log(`afterCellChange ${JSON.stringify(newplayerEditingData[rowIndex])} `);
    newplayerEditingData[rowIndex][key] = changeArray[3];
  };

  componentWillUnmount() {
    this.props.onRef(undefined);
    clearInterval(this.interval);
  }
  async componentWillReceiveProps(nextProps) {}
  updateWindowDimensions() {
    this.setState({ tableHeight: window.innerHeight });
    let tableHeight = window.innerHeight - 200;
    this.props.setEditTableHeight(tableHeight);
  }

  /**
   * 儲存功能 ==========================================
   * 更新資料後 處理介面(表單 拖拉區 字幕)
   * */
  saveData_update_EditTable_ITManPlayer_WaveGroup = (data) => {
    //更新內存資料
    this.DataObjArray.setArray(data);

    //更新EditTable表單資料
    this.hotTableComponent.current.hotInstance.loadData(data);
    this.props.updateEditTableData(this.DataObjArray.getContent());

    //更新拖拉區
    this.initWaveSubAndDragData();

    /***
     *
     * 如果是在播放中的狀況 就要停止
     *
     */
    const { player } = this.player.getState();
    if (player.paused === true) {
      //更新字幕
      SubTitleUtils.updateAllTrack(this);
    }
    //檢查錯誤
    //this.StyleData.c
  };

  /**
   * 拖拉相關功能 ==========================================
   * */
  handleDrag = (ev, ui) => {
    //取得當前的
    //  this.handleDragValue = (ui.x);

    //位移
    const currentLeft = document
      .getElementById('waveform-frame')
      .style.left.replace('px', '');
    this.handleDragValue = parseFloat(currentLeft) + ui.x;
    if (this.handleDragValue > 0) {
      this.handleDragValue = 0;
    }

    this.props.setHandleDragValue(this.handleDragValue);
  };

  setDragHandleDragValue_byIndex(row) {
    const data = this.DataObjArray.getContent();
    const rowData = new DataObj(data[row]);
    rowData.setTSubType(WaveformView.projectSubType);
    const timeSeconds = rowData.start;

    // console.log('timeSeconds ' + timeSeconds);
    // console.log('rowData.start ' + rowData.start);

    const videoCurrentTime = parseFloat(rowData.start);
    //const videoCurrentTime = ZeroTimeUtils.getPlayerRightTime(parseFloat(rowData.start));

    //更新字幕
    this.Last_videoCurrentTime = videoCurrentTime;
    this.Last_currentDataIndex = row;

    this.player.seek(videoCurrentTime);
    DragHandleUtils.setDragHandleDragValue(timeSeconds);
  }

  //拖拉點擊
  popDoubleClick(e) {
    const element = e.currentTarget;
    const index = parseFloat(`${element.id}`.replace('popup_', ''));

    //灰框點擊兩下
    DragHandleUtils.setDoubleClick(this, index);
  }

  /**
   * 表單相關功能 ==========================================
   * */
  async cutTC(row, col) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    const { player } = this.player.getState();

    let data = this.DataObjArray.getContent();
    let dataObj = data[row];

    // 如果在編輯狀態就不切
    if (this.isEditing === false) {
      // 影片切
      if (col === 0) {
        //IN
        dataObj.setInOut('In', player.currentTime);
        // DocumentUtils.updateInOutHighlight('In',dataObj);
      } else if (col === 1) {
        //Out
        dataObj.setInOut('Out', player.currentTime);
        //更新表格
        // DocumentUtils.updateInOutHighlight('Out',dataObj);
      }

      this.DataObjArray.updateDataObj_by_index(row, dataObj);

      if (col === 0 && this.state.isInputLatencyAct === true) {
        //檢察 把in往前推
        await this.DataObjArray.checkInputLatency(
          row,
          this.state.inputLatencyFrameNum,
          TimeUtils.getFPS()
        );
      }

      /**
       * 使用者要切出新的資料時 要開始擴增內容與新增拖拉區
       * */

      //如果資料到底 要繼續往下新增
      if (row === this.DataObjArray.getLength() - 1 && col === 1) {
        this.DataObjArray.addEmpRow();
        // DocumentUtils.Add_Emp_Popup();
      }

      //移動位置
      let element = this.popups[row];
      const elementLeft = dataObj.getDragEleLeft();
      const elementWidth = dataObj.getDragEleWidth();
      element.style.left = elementLeft + 'px';
      element.style.width = elementWidth + 'px';

      //更新總資料
      this.saveData_update_EditTable_ITManPlayer_WaveGroup(
        this.DataObjArray.getContent()
      );

      //更新
      //this.updateDragElement();

      //有編輯
      this.setIsEdit(true);
    } else {
      this.props.editTable;
    }

    //移動到下一個
    let nextCol = 0;
    if (col === 0) {
      nextCol = 1;
    }
    let nextrow = row;
    if (col === 1) {
      nextrow = 1 + row;
    }
    this.hotTableComponent.current.hotInstance.selectCell(nextrow, nextCol);
  }
  async ITManPlayer_play(row) {
    let data = this.DataObjArray.getContent();
    const rowData = new DataObj(data[row]);
    rowData.setTSubType(WaveformView.projectSubType);
    const timeSeconds = rowData.start;

    await this.setDragHandleDragValue_byIndex(row);
    //await this.player.seek(ZeroTimeUtils.getPlayerRightTime(timeSeconds));
    await this.player.seek(timeSeconds + 0.01);
    this.pause();

    //await this.play();
    setTimeout(
      function () {
        this.play();
      }.bind(this),
      500
    );
  }
  //按下stop
  async timecode_stopClick() {
    // console.log(`逐步檢 浮動cellCoords_row: ${this.cellCoords_row}`)
    let data = this.DataObjArray.getContent();
    let dataObj = data[this.cellCoords_row];
    let timeString;
    let timeSeconds;

    if (this.cellCoords_col === 0) {
      //In 時間
      timeString = dataObj.In;
      timeSeconds = dataObj.start;
    } else {
      //Out 時間
      timeString = dataObj.Out;
      timeSeconds = dataObj.end;
    }

    //檢察是不是時間字串
    if (
      StringUtils.checkIsEffectiveTimeString(dataObj.In) === false ||
      StringUtils.checkIsEffectiveTimeString(dataObj.Out) === false
    ) {
      return;
    }

    //更新畫面
    this.time_displayRef.innerHTML = ZeroTimeUtils.TimeDisplayRef_Text(
      timeSeconds,
      this.totalPlayTime
    );

    // console.log(`逐步檢  我點到哪一秒: ${timeSeconds}`)

    // 從Time string來計算出秒數
    if (true) {
      const timeArray = timeString.split('.');
      const h_m_s_string = timeArray[0];
      const h_m_s_array = h_m_s_string.split(':');
      const framnumber = parseFloat(timeArray[1]);
      const frameToSecond = framnumber / TimeUtils.getFPS();

      const totalSecond =
        parseFloat(h_m_s_array[0]) * 60 * 60 +
        parseFloat(h_m_s_array[1]) * 60 +
        parseFloat(h_m_s_array[2]) +
        frameToSecond;

      //要更新影片現在的影片時間
      this.Last_videoCurrentTime = totalSecond;
      this.isPlay = false;
      await this.player.seek(totalSecond);
      //  await this.player.seek(ZeroTimeUtils.getPlayerRightTime(timeSeconds));
      //await this.player.seek(ZeroTimeUtils.getPlayerRightTime(toTime));

      // this.isPlay = false;
      // this.pause();

      DragHandleUtils.setDragHandleDragValue(totalSecond);
    } else {
      //要更新影片現在的影片時間
      this.Last_videoCurrentTime = timeSeconds;
      this.isPlay = false;
      await this.player.seek(timeSeconds);
      //  await this.player.seek(ZeroTimeUtils.getPlayerRightTime(timeSeconds));
      //await this.player.seek(ZeroTimeUtils.getPlayerRightTime(toTime));

      // this.isPlay = false;
      // this.pause();

      DragHandleUtils.setDragHandleDragValue(timeSeconds);
    }
  }
  get reduxHotSettings() {
    // let tableData = this.props.editTable;
    // tableData.data = this.DataObjArray.getContent();
    //
    //
    // console.log("111111111111111111111111 tableData");
    // console.log(tableData);
    // console.log("------------------------ this.props.editTable");
    // console.log(this.props.editTable);
    // console.log("------------------------ this.props.editTable.data");
    // console.log(this.props.editTable.data);
    // console.log("------------------------ this.DataObjArray.getContent()");
    // console.log(this.DataObjArray.getContent());

    //原來方式
    return this.props.editTable;

    // let tableData = this.props.editTable;
    // tableData.data = this.DataObjArray.getContent();
    //
    // return tableData;
  }
  //按鍵 左右新增或刪除
  async chevronEvent(direction) {
    this.DragSubtitleWidth(this.cellCoords_row, this.cellCoords_col, direction);
  }
  /** 回復上一步驟的紀錄*/
  saveLastData(data, dataIndex) {
    const dataObj = data[dataIndex];
    //修正前 做一個紀錄
    let allBefore = this.befoCellChangeData;
    allBefore.push({
      rowIndex: dataIndex,
      In: dataObj.In,
      Out: dataObj.Out,
      start: dataObj.start,
      end: dataObj.end,
      SubtitleCaption: dataObj.SubtitleCaption,
      Memo: dataObj.Memo,
    });
    this.befoCellChangeData;
  }

  //展開
  delete_Row(deleteRowIndex) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    if (window.confirm('Delete this row?')) {
      this.updateSubTitle_by_row_frame(deleteRowIndex);

      this.DataObjArray.delete_mutile_Row(deleteRowIndex, 1);

      //移動到表單特定位置
      this.hotTableComponent.current.hotInstance.selectCell(
        deleteRowIndex,
        this.blue_col
      );

      //更新總資料
      this.saveData_update_EditTable_ITManPlayer_WaveGroup(
        this.DataObjArray.getContent()
      );

      //有編輯
      this.setIsEdit(true);
    }
  }

  //刪除多行
  mutile_delete_Row() {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    if (window.confirm('Delete all rows?')) {
      const startRow = this.selectStart;
      const endRow = this.selectEnd;
      const totlaCount = endRow - startRow + 1;

      //資料刪除
      this.DataObjArray.delete_mutile_Row(startRow, totlaCount);

      //拖拉刪除
      // DocumentUtils.RemovePopup_mutile_Row(startRow, totlaCount);

      //刪除表格Row
      // this.hotTableComponent.current.hotInstance.alter('remove_row',startRow,totlaCount);

      //移動到表單特定位置
      this.hotTableComponent.current.hotInstance.selectCell(
        startRow,
        this.blue_col
      );

      //更新總資料
      this.saveData_update_EditTable_ITManPlayer_WaveGroup(
        this.DataObjArray.getContent()
      );

      //有編輯
      this.setIsEdit(true);
    }
  }

  //展開
  resize_full(type) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }
    console.log('======= resize_full ========');
    // CPS: -0.3
    // Duration: "50.84"
    // DurationTitle: "0.00\n(0)"
    // In: "00:00:49.05"
    // InTimecode: "00:00:00,000"
    // Length: "12"
    // LengthTitle: "12"
    // Memo: ""
    // Out: "00:00:50.21"
    // OutTimecode: "00:00:50,840"
    // Position: ""
    // ShotChange: ""
    // Source: ""
    // SubtitleCaption: "I mean… Aan."
    // start: 0
    // end: 50.84

    let data = this.DataObjArray.getContent();
    let rowIndx = this.cellCoords_row;

    if (type === 'blue') {
      rowIndx = this.blue_row;
    }
    //console.log(`  resize_full ${this.DataObjArray.dataArry.length} rowIndx ${rowIndx}`)

    //產生一個新的物件 來安插
    let newDataObj = new DataObj(this.DataObjArray.getObj(rowIndx));
    newDataObj.setTSubType(WaveformView.projectSubType);

    //把資料 插入一個新的
    // this.DataObjArray.add_empty_Row(rowIndx);
    // this.DataObjArray.updateDataObj_by_index(rowIndx,dataObj);
    data.splice(rowIndx, 0, newDataObj);

    //新增結束
    //當前物件
    let currentDataObj = newDataObj;

    //展開的下一格時間
    var nextOutString = currentDataObj.Out;

    let currentInFrame = TimeUtils.timeString_convertTo_frame(
      currentDataObj.In,
      this.videoFps
    );
    let currentOutFrame = TimeUtils.timeString_convertTo_frame(
      currentDataObj.Out,
      this.videoFps
    );

    let currentNewOutFrame =
      (currentOutFrame - currentInFrame) / 2 + currentInFrame - 2;
    let currentNewOutTimeString = TimeUtils.getTimeStringFrom_FrameCount(
      currentNewOutFrame,
      this.videoFps
    );

    //當前物件 設定結束時間
    currentDataObj.setInOut('Out', currentNewOutTimeString);

    //下一個物件
    let nextDataObj = new DataObj(this.DataObjArray.getObj(rowIndx));
    nextDataObj.setTSubType(WaveformView.projectSubType);
    let nextDataObj_in = TimeUtils.getTimeStringFrom_FrameCount(
      currentNewOutFrame + 2,
      this.videoFps
    );

    nextDataObj.setInOut('In', nextDataObj_in);
    nextDataObj.setInOut('Out', nextOutString);

    data[rowIndx] = currentDataObj; //更新當前index的資料
    data[rowIndx + 1] = nextDataObj; //安插進去的資料

    this.saveData_update_EditTable_ITManPlayer_WaveGroup(data); //送資料儲存

    //有編輯
    this.setIsEdit(true);

    console.log('======= end of resize_full ========');
  }
  //合併下一個
  resize_small(type) {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }
    let data = this.DataObjArray.getContent();
    let rowIndx = this.cellCoords_row;

    if (type === 'blue') {
      rowIndx = this.blue_row;
    }

    //當前
    let dataObj = data[rowIndx];
    let currentDataObj = new DataObj(dataObj);
    currentDataObj.setTSubType(WaveformView.projectSubType);

    //下一個 拿資料用
    let n_dataObj = data[rowIndx + 1];
    let nextDataObj = new DataObj(n_dataObj);

    //設定結尾時間
    currentDataObj.setInOut('Out', nextDataObj.Out);

    //設定文字
    let newString = `${currentDataObj.getSubtitleCaption()}\n${nextDataObj.getSubtitleCaption()}`;
    currentDataObj.setSubtitleCaption(newString);

    data[rowIndx] = currentDataObj;

    //移除 rowIndx + 1
    data.splice(rowIndx + 1, 1);

    this.saveData_update_EditTable_ITManPlayer_WaveGroup(data); //送資料儲存

    //
    this.updateInstanceTable_by_Row(rowIndx);

    //
    //this.delete_Row(rowIndx + 1);

    //拖拉移除
    //DocumentUtils.RemovePopup_By_Index(rowIndx+1);
    //this.hotTableComponent.current.hotInstance.alter('remove_row',(rowIndx+1),1);

    //有編輯
    this.setIsEdit(true);
  }

  /**
   * 進行Style檢察
   * */
  tableRunTargetCheck() {
    if (this.isEnableStyleCheck === true) {
      let self = this;
      this.StyleData.runTargetCheck(
        this.DataObjArray.getContent(),
        function (errorArray) {
          self.frameSpliteErrorArray = errorArray['frameSpliteErrorArray'];

          //console.log(self.frameSpliteErrorArray);
          //console.log(errorArray['TotalErrorData']);
          //console.log(errorArray);
          // frameSpliteErrorArray:newTargetErrorArray,
          //更新表格
          self.hotTableComponent.current.hotInstance.loadData(
            self.DataObjArray.getContent()
          );
        }
      );
    }
  }

  //快捷鍵跟按鍵的字幕增減
  async DragSubtitleWidth(row, col, way) {
    //做增減所使用的間隔
    const targetFrameSplit = parseFloat(
      document.getElementById('findFrameSplitValue').value
    );
    const frameGAP = this.StyleData.fFrameSplit; //style 設定 Out TC跟下一個In TC的間隔

    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    let data = this.DataObjArray.getContent();
    let dataObj = new DataObj(data[row]);
    let timeString;

    //修正前 做一個紀錄
    //this.saveLastData(data,row);

    if (col === 0) {
      //In 時間
      timeString = dataObj.In;
    } else if (col === 1) {
      //Out 時間
      timeString = dataObj.Out;
    }

    let finalTimeString = '';
    if (way === 'left') {
      //左邊開始增加 要往前剪
      finalTimeString = StringUtils.checkTimeString(
        TimeUtils.useStringCountFrame(
          timeString,
          TimeUtils.getFPS(),
          parseFloat(targetFrameSplit) * -1
        )
      );

      if (row > 0) {
        const lastDataIndex = row - 1;
        let lastDataObj = new DataObj(data[lastDataIndex]);

        //上一個時機點
        let lastOutFrame = TimeUtils.timeString_convertTo_frame(
          lastDataObj.Out
        );
        let currentInFrame =
          TimeUtils.timeString_convertTo_frame(finalTimeString);

        const distant = currentInFrame - lastOutFrame;

        if (distant < parseFloat(frameGAP) || distant <= 0) {
          lastDataObj.setInOut(
            'Out',
            TimeUtils.useStringCountFrame(
              finalTimeString,
              TimeUtils.getFPS(),
              parseFloat(frameGAP) * -1
            )
          );

          data[lastDataIndex] = lastDataObj;

          //更新table
          this.UpdateSpecificGraySquare_Size(lastDataIndex);

          this.hotTableComponent.current.hotInstance.setDataAtRowProp(
            parseInt(lastDataIndex, 10),
            'Out',
            lastDataObj.Out
          );
          this.hotTableComponent.current.hotInstance.setDataAtRowProp(
            parseInt(lastDataIndex, 10),
            'Duration',
            lastDataObj.Duration
          );
        }
      }
    } else {
      //右邊增加
      finalTimeString = StringUtils.checkTimeString(
        TimeUtils.useStringCountFrame(
          timeString,
          parseFloat(TimeUtils.getFPS()),
          parseFloat(targetFrameSplit)
        )
      );

      //檢察上一個的out時間有沒有重疊
      let nextIndex = row + 1;

      let nextDataObj = new DataObj(data[nextIndex]);

      let currentOutFrame =
        TimeUtils.timeString_convertTo_frame(finalTimeString);

      //下一個In不是空的才可以位移
      if (nextDataObj.In !== '') {
        let nextInFrame = TimeUtils.timeString_convertTo_frame(nextDataObj.In);

        const distant = nextInFrame - currentOutFrame;

        if (distant <= parseFloat(frameGAP)) {
          nextDataObj.setInOut(
            'In',
            TimeUtils.useStringCountFrame(
              finalTimeString,
              TimeUtils.getFPS(),
              parseFloat(frameGAP)
            )
          );

          data[nextIndex] = nextDataObj;

          //更新table
          this.UpdateSpecificGraySquare_Size(nextIndex);

          this.hotTableComponent.current.hotInstance.setDataAtRowProp(
            parseInt(nextIndex, 10),
            'In',
            nextDataObj.In
          );
          this.hotTableComponent.current.hotInstance.setDataAtRowProp(
            parseInt(nextIndex, 10),
            'Duration',
            nextDataObj.Duration
          );
        }
      } else {
        //只移動自己
      }
    }

    //最後更新
    if (col === 0) {
      //In 時間
      dataObj.setInOut('In', finalTimeString);
      //更新table
      this.hotTableComponent.current.hotInstance.setDataAtRowProp(
        parseInt(row, 10),
        'In',
        dataObj.In
      );
    } else {
      //Out 時間
      dataObj.setInOut('Out', finalTimeString);
      //更新table
      this.hotTableComponent.current.hotInstance.setDataAtRowProp(
        parseInt(row, 10),
        'Out',
        dataObj.Out
      );
    }
    this.hotTableComponent.current.hotInstance.setDataAtRowProp(
      parseInt(row, 10),
      'Duration',
      dataObj.Duration
    );

    data[row] = dataObj;

    this.DataObjArray.updateDataObj_by_index(row, dataObj);

    this.UpdateSpecificGraySquare_Size(row);

    //有編輯
    this.setIsEdit(true);

    /**
     * 處理影像移動
     * */
    if (col === 0) {
      //In 時間
      this.player.seek(dataObj.start);
    } else if (col === 1) {
      //Out 時間
      this.player.seek(dataObj.end);
    }

    this.saveData_update_EditTable_ITManPlayer_WaveGroup(
      this.DataObjArray.getContent()
    );
  }

  moveCellSelect(currentDataIndex) {
    this.Last_currentDataIndex = currentDataIndex;
    this.currentDataIndex = currentDataIndex;
    this.hotTableComponent.current.hotInstance.selectCell(
      parseInt(currentDataIndex, 10),
      0
    );
  }
  //posirion位置
  arrowUpOrDown(way, newIndex) {
    let data = this.DataObjArray.getContent();
    let dataObj = this.DataObjArray.getObj(newIndex);

    let orgPosition = parseFloat(dataObj.Position);

    let PositionResult = '';

    if (parseFloat(this.StyleData.fAllowPositioningType) === 0) {
      //Top/Bottom Only (Netflix TTML)

      if (dataObj.Position === '') {
        //原地 只接受網上
        if (parseFloat(way) === 1) {
          // //往上
          PositionResult = 1;
          //PositionResult = 1;
        }
      } else {
        if (parseFloat(way) === 1) {
          //往上
          //PositionResult = `${(parseFloat(dataObj.Position) < 1) ? (parseFloat(dataObj.Position) + 0.1).toFixed(1) : dataObj.Position}`;

          PositionResult = 1;
        } else if (parseFloat(way) === 0) {
          //countPostiion = (parseFloat(dataObj.Position) - 0.1).toFixed(1);
          //countPostiion = (parseFloat(dataObj.Position) - 0.1).toFixed(1);

          //往下
          //PositionResult = `${(parseFloat(dataObj.Position) > 0) ? countPostiion : dataObj.Position}`;

          //歸0
          PositionResult = '';
        }
      }
    } else {
      //Left,Center, Right, Line Down, Line Up

      //計算
      let countPostiion = 0;

      if (parseFloat(way) === 1) {
        if (dataObj.Position === '') {
          //原地 只接受網上
          //往上
          PositionResult = 0.1;
        } else {
          // //往上
          // PositionResult = '1'
          //往上
          PositionResult = `${
            parseFloat(dataObj.Position) < 1
              ? parseFloat((parseFloat(dataObj.Position) + 0.1).toFixed(1))
              : dataObj.Position
          }`;
        }
      } else if (parseFloat(way) === 2) {
        if (orgPosition === 3) {
          PositionResult = '';
        } else {
          //往右
          PositionResult = '2';
        }
      } else if (parseFloat(way) === 3) {
        if (orgPosition === 2) {
          PositionResult = '';
        } else {
          //往右
          PositionResult = '3';
        }
      } else if (parseFloat(way) === 0) {
        countPostiion = parseFloat(
          (parseFloat(dataObj.Position) - 0.1).toFixed(1)
        );
        PositionResult = `${
          parseFloat(dataObj.Position) > 0 ? countPostiion : dataObj.Position
        }`;

        //歸0
        if (parseFloat(countPostiion) === 0) {
          PositionResult = '';
        }

        //往下
        if (orgPosition === 2) {
          PositionResult = '';
        } else if (orgPosition === 3) {
          PositionResult = '';
        }
      }
    }

    dataObj.Position = PositionResult;
    data[newIndex] = dataObj;

    this.hotTableComponent.current.hotInstance.setDataAtRowProp(
      parseInt(newIndex, 10),
      'Position',
      dataObj.Position
    );

    this.DataObjArray.updateDataObj_by_index(newIndex, dataObj);

    //移動到該位置
    this.player.seek(dataObj.start + 0.01);

    //更新資料
    this.saveData_update_EditTable_ITManPlayer_WaveGroup(
      this.DataObjArray.getContent()
    );

    //更新位置
    this.subMove(parseFloat(PositionResult));
  }

  //從hotkey 點兩下
  DoubleClick_from_hotkey(Event, selectionArray) {
    Event.preventDefault();
    Event.stopImmediatePropagation();

    //灰框點擊兩下
    DragHandleUtils.setDoubleClick(this, selectionArray[0]);
  }

  //從hotkey加Music標籤
  decorativeMusic_from_hotkey(Event) {
    Event.preventDefault();
    Event.stopImmediatePropagation();
    this.decorativeMusic();
  }

  //從hotkey加標籤
  decorativeLettering_from_hotkey(Event) {
    Event.preventDefault();
    Event.stopImmediatePropagation();
    this.decorativeLettering(true);
  }

  //家標籤
  decorativeLettering(isFromeHotkey) {
    let targetRowIndex = this.cellCoords_row;
    //跟隨藍框框
    if (isFromeHotkey === true) {
      var selection = this.hotTableComponent.current.hotInstance.getSelected();
      let selectionArray = selection[0];
      let row = selectionArray[0];
      targetRowIndex = row;
    }

    let data = this.DataObjArray.getContent();
    let dataObj = new DataObj(data[targetRowIndex]);

    let orgString = dataObj.SubtitleCaption;
    let newString = '';

    //Check it is html or not
    newString = SubTitleUtils.setItalicStyle(
      orgString,
      !orgString.includes('<i>')
    );

    let currentDataObj = new DataObj(dataObj);
    currentDataObj.setSubtitleCaption(newString);
    data[targetRowIndex] = currentDataObj;

    //更新
    this.saveData_update_EditTable_ITManPlayer_WaveGroup(data);

    //有編輯
    this.setIsEdit(true);
  }

  //加音符
  decorativeMusic() {
    let data = this.DataObjArray.getContent();

    //targetIndex
    var selection = this.hotTableComponent.current.hotInstance.getSelected();
    let selectionArray = selection[0];
    let targetIndex = selectionArray[0];
    let dataObj = new DataObj(data[targetIndex]);

    let orgString = dataObj.SubtitleCaption;
    let newString = `♪${orgString}♪`;

    let currentDataObj = new DataObj(dataObj);
    currentDataObj.setSubtitleCaption(newString);
    data[targetIndex] = currentDataObj;

    this.saveData_update_EditTable_ITManPlayer_WaveGroup(data); //送資料儲存

    //有編輯
    this.setIsEdit(true);
  }
  Jump_Backward_Forward(direction) {
    const { player } = this.player.getState();
    //移動
    if (direction === 'left') {
      this.Last_videoCurrentTime = player.currentTime - this.forwardSeconds;
    } else {
      this.Last_videoCurrentTime = player.currentTime + this.forwardSeconds;
    }

    this.player.seek(this.Last_videoCurrentTime);
  }
  setFindAllSelectRowCol(row, col) {
    this.hotTableComponent.current.hotInstance.selectCell(
      parseInt(row, 10),
      parseInt(col, 10)
    );
  }
  //從快捷鍵新增row

  /**
   * 安插 新的空白欄位
   * @returns
   */
  async add_Row_from_ctrl_i() {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    //資料新增
    await this.DataObjArray.add_empty_Row(this.blue_row);

    //表格新增
    //this.hotTableComponent.current.hotInstance.alter('insert_row',this.blue_row);

    //新增拖拉
    //DocumentUtils.Add_new_Popup_By_Index(this.blue_row);

    await this.saveData_update_EditTable_ITManPlayer_WaveGroup(
      this.DataObjArray.getContent()
    );
    // this.UpdateAllSquare();

    //有編輯
    await this.setIsEdit(true);
  }
  //滑鼠點擊加號鍵
  add_Row_from_click() {
    //isTimecodeLock設定的話就不能拖拉
    if (
      parseFloat(this.projectDetial.isTimecodeLock) === 1 ||
      parseInt(this.props.match.params.tType, 10) === 0
    ) {
      return;
    }

    //資料新增
    this.DataObjArray.add_empty_Row(this.cellCoords_row);

    //新增拖拉
    //DocumentUtils.Add_new_Popup_By_Index(this.cellCoords_row);
    this.saveData_update_EditTable_ITManPlayer_WaveGroup(
      this.DataObjArray.getContent()
    );
    // this.UpdateAllSquare();

    //有編輯
    this.setIsEdit(true);
  }

  /**
   * 播放相關功能 ==========================================
   * */
  play() {
    this.player.play();
    this.isPlay = true;
    this.ifShowPlayIcon(true);

    //拖拉區的移動 依照撥放速度
    //DragAreaMoveStart();
  }
  pause() {
    this.player.pause();
    this.isPlay = false;
    this.ifShowPlayIcon(false);

    //定出停止時間
    const { player } = this.player.getState();
    this.playerStopTime = player.currentTime;

    //拖拉區的移動 依照撥放速度
    //DragAreaMoveStop();
  }
  handleStateChange(state) {
    const { player } = this.player.getState();

    /**只取一次總時間 設定總時間*/
    if (typeof state.duration == 'number') {
      if (state.duration > 0 && this.isSetDuration === false) {
        this.player.preload = 'auto';

        this.props.set_video_duration(state.duration);
        this.isSetDuration = true;
        this.setState({ videoDuration: state.duration });

        //總時間長度
        this.totalPlayTime = TimeUtils.convertSecondToTimeString(
          state.duration + ZeroTimeUtils.getZerotimeSeconds(),
          this.videoFps
        );
      }
    }

    //顯示時間
    this.time_displayRef.innerHTML = ZeroTimeUtils.TimeDisplayRef_Text(
      player.currentTime,
      this.totalPlayTime
    );

    //更新更新字幕
    if (this.isPlay === true || state.seeking === true) {
      //設定位

      /**
       * 位移分開處理
       * */
      DragHandleUtils.setDragHandleDragValue(player.currentTime);

      //this.setState({videoCurrentTime:player.currentTime});

      this.Last_videoCurrentTime = player.currentTime;
    } else {
      //停下後要固定位置
      this.Last_videoCurrentTime = this.playerStopTime;
    }
  }

  //返回所選到的字幕
  updateSubTitle_by_row_frame = (currentDataIndex) => {
    console.log('=== updateSubTitle_by_row_frame ===');

    const { player } = this.player.getState();

    //const SubtitleData = this.state.SubtitleData;
    const SubtitleData = this.DataObjArray.getContent();

    //取出字幕 更新
    if (SubtitleData.length !== 0) {
      const currentRowData = new DataObj(SubtitleData[currentDataIndex]);
      const { SubtitleCaption, Position, In, Out, start, end } = currentRowData;
      //const In_Seconds = ZeroTimeUtils.getPlayerRightTime(parseFloat(start)) ;
      //const Out_Seconds = ZeroTimeUtils.getPlayerRightTime(parseFloat(end)) ;
      const In_Seconds = start;
      const Out_Seconds = end;

      // console.log(` In_timeFrame ${In_Seconds}
      // curentFrame ${player.currentTime}
      //  Out_timeFrame ${Out_Seconds}`)
      //
      // //時間內
      if (parseFloat(player.currentTime) < parseFloat(In_Seconds)) {
        // console.log(`1 In_timeFrame 清空字幕`)
        //清空字幕
        //this.captionTextRef.innerHTML = "";
      } else if (parseFloat(Out_Seconds) < parseFloat(player.currentTime)) {
        // // console.log(`2 In_timeFrame 清空字幕`)
        // //清空字幕
        // this.captionTextRef.innerHTML = "";
      } else {
        this.subMove(Position);

        //更新黃底的Row 並顯示
        this.saveData_update_EditTable_ITManPlayer_WaveGroup(
          this.DataObjArray.getContent()
        );
      }
    }
    //更新字幕
    SubTitleUtils.updateTrack(this, currentDataIndex);
  };
  subMove_justMove = (way) => {
    if (parseFloat(this.StyleData.fAllowPositioningType) === 0) {
      this.textAlign = 'center';
      this.top = '';
      this.bottom = '40px';

      if (isNaN(way) === true) {
        this.bottom = '40px';
      } else {
        let finalBottom = 40 + 165 * way;
        this.bottom = `${finalBottom}px`;
      }
      let countNum = 0;
      if (parseFloat(way) === 0) {
        this.textAlign = 'center';
        this.top = '';
        this.bottom = '40px';
      } else if (parseFloat(way) === 1) {
        this.textAlign = 'center';
        this.top = '24px';
        this.bottom = '';
      } else if (parseFloat(way) === 2) {
        this.textAlign = 'right';
        this.top = '';
        this.bottom = '40px';
      } else if (parseFloat(way) === 3) {
        this.textAlign = 'left';
        this.top = '';
        this.bottom = '40px';
      }

      if (way === '') {
        this.textAlign = 'center';
        this.top = 'auto';
        this.bottom = '24px';
      }

      // if (parseFloat(way) === 1) {
      //     this.textAlign = 'center';
      //     this.top = '24px';
      //     this.bottom = '';
      // }
    } else {
      if (way === '') {
        this.textAlign = 'center';
        this.top = '';
        this.bottom = '40px';
      } else if (parseFloat(way) === 0) {
        this.textAlign = 'center';
        this.top = '';
        this.bottom = '40px';
      } else if (parseFloat(way) === 1) {
        this.textAlign = 'center';
        this.top = '24px';
        this.bottom = '';
      } else if (parseFloat(way) === 2) {
        this.textAlign = 'right';
        this.top = '';
        this.bottom = '40px';
      } else if (parseFloat(way) === 3) {
        this.textAlign = 'left';
        this.top = '';
        this.bottom = '40px';
      } else {
        let finalBottom = 40 + 165 * way;
        this.bottom = `${finalBottom}px`;
      }
    }

    //設定位置
    this.way = way;
    let CaptionContainer = document.getElementById('CaptionContainer');
    CaptionContainer.style.textAlign = this.textAlign;
    CaptionContainer.style.fontSize = `${this.CaptionContainerFontSize}pt`;
    CaptionContainer.style.top = this.top;
    CaptionContainer.style.bottom = this.bottom;
  };

  subMove = (way) => {
    this.subMove_justMove(way);

    //儲存
    this.saveData_update_EditTable_ITManPlayer_WaveGroup(
      this.DataObjArray.getContent()
    );
  };
  insertSymblo = (symblo) => {
    let data = this.DataObjArray.getContent();
    let dataObj = new DataObj(data[this.blue_row]);
    dataObj.setSubtitleCaption(`${dataObj.SubtitleCaption}${symblo}`);

    data[this.blue_row] = dataObj;

    this.saveData_update_EditTable_ITManPlayer_WaveGroup(data);

    //有編輯
    this.setIsEdit(true);
  };
  changePlaybackRateRate(steps) {
    this.player.playbackRate = steps;
    return () => {};
  }
  changeCurrentTime(seconds) {
    this.player.seek(seconds);
  }

  //顯示 play 或是 stop
  ifShowPlayIcon(show) {
    DocumentUtils.changePlayerPlayBtn(show);
  }

  updatefindFrameSplitValue(value) {
    if (value !== '') {
      this.findFrameSplitValue = value;
    }

    //更新後 檢查一次
    this.checkFrameSplitErrorArray();
  }
  //更新影片移動幅度
  updateforwardSeconds(value) {
    if (value !== '') {
      this.forwardSeconds = value;
    }
  }

  //檢查錯誤
  checkFrameSplitErrorArray() {
    //更新frame資料
    // this.frameSpliteErrorArray = TimeUtils.getFrameSplitErrorArray(
    //     this.DataObjArray.getContent(),
    // this.StyleData.fFrameSplit,
    // this.videoFps);
    //this.frameSpliteErrorArray = TimeUtils.getFrameSplitErrorArray(this.DataObjArray.getContent(),this.findFrameSplitValue,this.props.videoFps);

    this.tableRunTargetCheck();
  }

  //移動小功能
  //設定位置
  setPosition(type, top, left) {
    if (type === 0) {
      //時間
      // this.setState({ timecode_top:top});
      // this.setState({ timecode_left:left});
      let timecodeComponent = document.getElementById('timecodeComponent');
      timecodeComponent.style.top = `${top}px`;
      timecodeComponent.style.left = `${left}px`;
      timecodeComponent.style.zIndex = 100;
    } else {
      //字幕
    }
  }

  //更新實體表格的內容 畫面更新效率低
  updateInstanceTable_by_Row(row) {
    const dataObj = new DataObj(this.DataObjArray.getObj(row));
    this.hotTableComponent.current.hotInstance.setDataAtRowProp(
      parseInt(row, 10),
      'In',
      dataObj.In
    );
    this.hotTableComponent.current.hotInstance.setDataAtRowProp(
      parseInt(row, 10),
      'Out',
      dataObj.Out
    );
    this.hotTableComponent.current.hotInstance.setDataAtRowProp(
      parseInt(row, 10),
      'Duration',
      dataObj.Duration
    );
    this.hotTableComponent.current.hotInstance.setDataAtRowProp(
      parseInt(row, 10),
      'SubtitleCaption',
      dataObj.SubtitleCaption
    );
    this.hotTableComponent.current.hotInstance.setDataAtRowProp(
      parseInt(row, 10),
      'Length',
      dataObj.Length
    );

    //更新錯誤的時間長度
    this.hotTableComponent.current.hotInstance.setDataAtCell(
      row,
      2,
      dataObj.Duration,
      'Duration'
    );
  }

  /**
   * 儲存相關功能 ==========================================
   * */
  //通知是否要顯示編輯變紅色
  setIsEdit(result) {
    if (result === false) {
      this.countSeconds = 0;
    }
    this.isEdit = result;
    DocumentUtils.changeSaveBtnColor(result);
  }

  //上傳
  async uploadTableData() {
    await this.setState({ uploadTableData_loading: true });

    this.countSeconds = 0;

    //更新比對記錄
    this.savedData = this.DataObjArray.getContent();

    const { user } = this.props.auth;
    const email = user['email'];

    //表格資料
    //原本的記憶體資料
    let dataIndex = 0;
    const tableData = this.props.editTable.data; //表格資料
    this.DataObjArray.getContent().forEach((listData) => {
      const petData = tableData[dataIndex];
      if (listData['SubtitleCaption'] === '' && petData !== undefined) {
        listData['SubtitleCaption'] = petData['SubtitleCaption'];
      }
      dataIndex += 1;
    });

    //儲存
    await this.props.AddDetialJsonData({
      tProjectDetialId: this.projectDetial.fId,
      jsonstring: this.DataObjArray.getContent(),
      email: email,
    });

    //更新version
    await this.props.get_versionData(this.projectDetial.fId);

    this.setIsEdit(false);
    this.setState({ uploadTableData_loading: false });

    //更新表格
    this.saveData_update_EditTable_ITManPlayer_WaveGroup(
      this.DataObjArray.getContent()
    );
  }

  //發送成功訊息出去
  async sendComplete() {
    return this.frameSpliteErrorArray;
  }

  initWaveSubAndDragData = () => {
    //初始拖拉資料
    this.DragData = SubTitleUtils.getInitDragData(
      this.videoFps,
      this.frameWidth,
      0,
      this.DataObjArray.getContent()
    );

    //更新拖拉內的文字
    //this.setState({DragData:this.DragData});

    //錯誤檢察
    this.checkFrameSplitErrorArray();
  };

  //界面
  //一般
  normalRowRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.HtmlRenderer.apply(this, arguments);
    td.style.background = '#ffffff';
    td.style.wordBreak = 'break-all';
    td.style.lineHeight = '14px';
    td.style.verticalAlign = 'bottom';
    td.style.textAlign = 'center';

    if (this.state.isBigFont === true) {
      if (prop === 'Source' || prop === 'SubtitleCaption') {
        td.style.lineHeight = '14pt';
        td.style.fontSize = '12pt';
      }
    }
  }
  //單選一行
  findOneLineRowRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.HtmlRenderer.apply(this, arguments);
    td.style.background = '#FFFF99';
    td.style.wordBreak = 'break-all';
    td.style.lineHeight = '14px';
    td.style.verticalAlign = 'bottom';
    td.style.textAlign = 'center';

    if (this.state.isBigFont === true) {
      if (prop === 'Source' || prop === 'SubtitleCaption') {
        td.style.lineHeight = '14pt';
        td.style.fontSize = '12pt';
      }
    }
  }
  mixRowRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.HtmlRenderer.apply(this, arguments);
    td.style.background = 'rgb(255,214,201)';
    // td.style.background = 'rgba(255, 118, 0, 0.2)';
    td.style.wordBreak = 'break-all';
    td.style.lineHeight = '14px';
    td.style.verticalAlign = 'bottom';
    td.style.textAlign = 'center';

    if (this.state.isBigFont === true) {
      if (prop === 'Source' || prop === 'SubtitleCaption') {
        td.style.lineHeight = '14pt';
        td.style.fontSize = '12pt';
      }
    }
  }
  errorRowRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.HtmlRenderer.apply(this, arguments);
    td.style.background = 'rgb(255,217,217)';
    // td.style.background = 'rgba(255, 0, 0, 0.2)';
    td.style.wordBreak = 'break-all';
    td.style.lineHeight = '14px';
    td.style.verticalAlign = 'bottom';
    td.style.textAlign = 'center';

    if (this.state.isBigFont === true) {
      if (prop === 'Source' || prop === 'SubtitleCaption') {
        td.style.lineHeight = '14pt';
        td.style.fontSize = '12pt';
      }
    }
  }
  /**
   * 快捷鍵
   * */
  onKeyUp(keyName, e, handle) {
    console.log('test:onKeyUp', keyName, e, handle);
    if (keyName === 'ctrl+down') {
      // this.Play_From_Selected_Row()
      const isPlayerStartData = this.props.context.isPlayerStart;
      if (isPlayerStartData.isPlay === true) {
        this.pause();
      } else {
        this.play();
      }
    }
  }

  setIsShowFindAllViewInput() {
    this.setState({
      isShowFindAllViewInput: !this.state.isShowFindAllViewInput,
    });
  }

  onKeyDown(keyName, e, handle) {
    if (keyName === 'ctrl+f') {
      this.setState({
        isShowFindAllViewInput: !this.state.isShowFindAllViewInput,
      }); 
    }

    if (keyName === 'ctrl+shift+d') {
      this.mutile_delete_Row();
    }
  }

  //輸出
  AccordionRowList({ targetObj }) {
    const listItems = targetObj.map((dataObj, index) => {
      return <div>{index}</div>;
    });

    return <ul>{listItems}</ul>;
  }

  render() {
    const { videoDuration } = this.state;
    const { videoFps, frameWidth } = this.state;
    const { ccEnable } = this.state; //字幕
    const { data, isShowSource } = this.state; //表單
    const { readOnly } = this.props.editTable;

    const { user } = this.props.auth;
    const email = user['email'];

    //影片長度
    let waveWidth = videoFps * videoDuration * frameWidth; //長度

    return this.state.loadInitData === true ? (
      <div className='pt-5'>
        <Spinner />
      </div>
    ) : (
      <HotkeysHook WaveformView={this}>
        <React.Fragment>
          <div
            id={'TranslationsTop'}
            className='position-relative'
            style={{ marginLeft: `150px`, height: '40px' }}
          >
            <h2>
              <span className={'pl-3'}>
                <Link to={`/`} target='_self'>
                  <img src={DWSlogo} alt='Logo' width={90} />
                </Link>
              </span>
              <small style={{ fontSize: '10pt' }} className={'pl-3'}>
                Hi,{this.props.auth.user.email}
              </small>

              <small style={{ fontSize: '12pt' }} className={'pl-3'}>
                Project Name:<b>{ProjectUtils.getEditingProjectTitle()}</b>
              </small>

              {WaveformView.projectSubType === 1 ? (
                <small style={{ fontSize: '12pt' }} className={'pl-3'}>
                  <Label>ttml</Label>
                </small>
              ) : null}

              {parseFloat(this.projectDetial.isTimecodeLock) === 1 ? (
                <small style={{ fontSize: '8px', paddingLeft: '5px' }}>
                  TC
                  <img
                    style={{ paddingLeft: '2px' }}
                    src={lockIcon}
                    width={12}
                  />
                </small>
              ) : (
                ''
              )}

              <small
                style={{ fontSize: '12pt' }}
                className={'pl-3'}
                onClick={() => {
                  this.props.setIsEditMode(true);
                }}
              >
                {parseInt(this.props.match.params.tType, 10) === 1 ? null : (
                  <Link
                    to={`/translations/1/${parseInt(
                      this.props.match.params.tIndex,
                      10
                    )}`}
                    target='_self'
                  >
                    {this.projectDetial.status === 1 ? (
                      <Button color='teal' size={'tiny'}>
                        Edit mode
                      </Button>
                    ) : null}
                  </Link>
                )}

                {parseInt(this.props.match.params.tType, 10) === 0 ? null : (
                  <Button
                    id={'SaveBtn'}
                    ref={(ref) => (this.SaveBtn = ref)}
                    loading={this.state.uploadTableData_loading}
                    color='grey'
                    size={'tiny'}
                    onClick={() => {
                      this.uploadTableData();
                    }}
                  >
                    Save
                  </Button>
                )}
                {/*管理者*/}
                {this.projectDetial.status === 2 &&
                email.includes('thesubpro.com') === true ? (
                  <Link
                    to={`/translations/1/${parseInt(
                      this.props.match.params.tIndex,
                      10
                    )}`}
                    target='_self'
                  >
                    <Button color='teal' size={'tiny'}>
                      Edit mode
                    </Button>
                  </Link>
                ) : null}
              </small>
            </h2>
          </div>

          <div
            className='main-toggle fa fa-bars float-right  position-fixed'
            onClick={() => {
              // this.isShowTranslationsNavbarAlert(!this.isShowTranslationsNavbar);
              this.setState({ isShowTranslationsNavbarAlert: true });
            }}
            style={{
              color: 'blue',
              fontSize: '16pt',
              top: '10px',
              right: '20px',
              zIndex: '100',
            }}
          >
            <Icon name='align justify' style={{ fontSize: `${15}pt` }} />
          </div>

          {/*所有的彈跳視窗*/}
          <PopupGroupList _WaveformView={this} />

          {/* <div style={{ height: '200px', overflow: 'scroll' }}>
            {this.shotchangeData
              ? this.shotchangeData.map((obj, index) => {
                  return (
                    <div>
                      <Button primary
                        onClick={() => {
                          this.player.seek(obj);
                        }}
                      >
                        影片取得秒數 ({obj}) [[Timecode:{TimeUtils.convertSecondToTimeString(obj,TimeUtils.getFPS())}]]
                      </Button>
                      <Button secondary
                        onClick={() => {
                          this.player.seek(parseFloat(obj,4)+1/24);
                        }}
                      >
                        累加1f ({parseFloat(obj,4)+1/24} ) [[Timecode:{TimeUtils.convertSecondToTimeString((parseFloat(obj,4)+1/24),TimeUtils.getFPS())}]]
                      </Button>
                    </div>
                  );
                })
              : null}
          </div> */}
         

          <div
            style={{
              position: 'relative',
              width: `${window.innerWidth - 15}px`,
              height:`${(window.innerHeight - 140)}px`
            }}
          >
            {/*表單*/}
            <div
              id='EditTable'
              style={{
                width: `${
                  window.innerWidth -
                  this.props.viewOperation.subtitles_Left -
                  88
                }px`,
                height: `${window.innerHeight - 200}px`,
                position: 'absolute',
                top: '5px',
                right: '0',
                zIndex: '0',
                overflow: 'hidden',
              }}
            >
              <small>
                <div
                  style={{
                    position: 'relative',
                    marginLeft: '0px',
                    height: `${window.innerHeight - 165}px`,
                  }}
                >
                  <HotTable
                    className='handsontable htRowHeaders htColumnHeaders'
                    ref={this.hotTableComponent}
                    //settings={this.reduxHotSettings}
                    settings={{
                      data: this.DataObjArray.getContent(),
                      manualColumnResize:
                        this.props.editTable['manualColumnResize'],
                      outsideClickDeselects:
                        this.props.editTable['outsideClickDeselects'],
                      fillHandle: this.props.editTable['fillHandle'],
                      undo: this.props.editTable['undo'],
                      rowHeaders: this.props.editTable['rowHeaders'],
                      readOnly: this.props.editTable['readOnly'],
                      colHeaders: this.props.editTable['colHeaders'],
                      height: this.props.editTable['height'],
                      editor: this.props.editTable['editor'],
                      colWidths: this.props.editTable['colWidths'],
                      columns: this.props.editTable['columns'],
                      cell: this.props.editTable['cell'],
                      selectStart: this.props.editTable['selectStart'], //藍框的index,
                      findAllSelectRowCol:
                        this.props.editTable['findAllSelectRowCol'], //目標位置

                      copyPaste: { columnsLimit: 2000, rowsLimit: 50000 },
                    }}
                    cells={(row, col, prop) => {
                      let findResult = false;
                      let errorCheck = false;

                      //點選檢查
                      const cellProperties = {};
                      if (row === parseInt(this.Last_currentDataIndex, 10)) {
                        findResult = true;
                      }

                      //影格錯誤
                      let errorObj =
                        this.frameSpliteErrorArray[parseInt(row, 10)];
                      if (errorObj !== undefined) {
                        if (errorObj.type === false) {
                          errorCheck = true;
                        }
                      }

                      //輸出
                      if (findResult === true && errorCheck === true) {
                        //選到錯誤
                        cellProperties.renderer = this.mixRowRenderer;
                      } else if (findResult === true) {
                        //選到
                        cellProperties.renderer = this.findOneLineRowRenderer;
                      } else if (errorCheck === true) {
                        cellProperties.renderer = this.errorRowRenderer;
                      } else {
                        cellProperties.renderer = this.normalRowRenderer;
                      }
                      return cellProperties;
                    }}
                    afterBeginEditing={(row, col) => {
                      //位置
                      this.setPosition(0, -1000, -1000);
                      this.subtitleViewComponent.setPosition(1, -1000, -1000);

                      this.isEditing = true;
                      // const selectData = data[row];
                      // this.beforeChangeData = {
                      //     rowIndex:row,
                      //     In:selectData.In,
                      //     Out:selectData.Out,
                      //     start:selectData.start,
                      //     end:selectData.end,
                      //     SubtitleCaption:selectData.SubtitleCaption,
                      //     Memo:selectData.Memo,
                      // };
                    }}
                    beforeChange={(changes, source) => {
                      this.isEditing = true;
                    }}
                    afterChange={(change, source) => {
                      this.isEditing = false;
                      // change.forEach(async([row, prop, oldValue, newValue]) => {
                      // })
                      // console.log(`change : ${change}`)
                      // console.log(`source : ${source}`)

                      if (change !== null) {
                        if (
                          source !== 'loadData' ||
                          `${change}`.includes('Duration') === false
                        ) {
                          this.isEditing = false;

                          if (source === 'CopyPaste.paste') {
                            //貼上
                          }

                          /**
                           * 一般編輯處理
                           *
                           * */
                          if (
                            source === 'edit' ||
                            source === 'CopyPaste.paste'
                          ) {
                            if (change.length < 10) {
                              const data = this.DataObjArray.getContent();

                              change.forEach(
                                ([row, prop, oldValue, newValue]) => {
                                  if (oldValue !== newValue) {
                                    const key = prop;

                                    if (
                                      key === 'In' ||
                                      key === 'Out' ||
                                      key === 'Memo' ||
                                      key === 'SubtitleCaption'
                                    ) {
                                      this.countSeconds = 0;

                                      //console.log('主資料更新');
                                      //主資料更新
                                      this.DataObjArray.updateChange(
                                        row,
                                        prop,
                                        oldValue,
                                        newValue
                                      );
                                      SubTitleUtils.updateTrack(this, row); //更新字幕

                                      //console.log(data);

                                      let currentObj = data[row];

                                      //字幕的話 更新長度
                                      // if(key === 'SubtitleCaption'){
                                      //     //更新長度
                                      //     this.hotTableComponent.current.hotInstance.setDataAtCell(
                                      //         row,
                                      //         (this.selectStart_col+1),
                                      //         currentObj.Length,
                                      //         'Length');
                                      // }
                                      //
                                      if (key === 'In' || key === 'Out') {
                                        //如果是輸入八碼
                                        if (`${newValue}`.length === 8) {
                                          const newTC = `${`${newValue}`.charAt(
                                            0
                                          )}${`${newValue}`.charAt(
                                            1
                                          )}:${`${newValue}`.charAt(
                                            2
                                          )}${`${newValue}`.charAt(
                                            3
                                          )}:${`${newValue}`.charAt(
                                            4
                                          )}${`${newValue}`.charAt(
                                            5
                                          )}.${`${newValue}`.charAt(
                                            6
                                          )}${`${newValue}`.charAt(7)}`;

                                          //主資料更新
                                          this.DataObjArray.updateChange(
                                            row,
                                            prop,
                                            oldValue,
                                            newTC
                                          ); //更新字幕
                                          SubTitleUtils.updateTrack(this, row); //更新字幕

                                          currentObj =
                                            this.DataObjArray.getObj(row);

                                          // console.log('-------------');
                                          // console.log(currentObj);

                                          //更新文字
                                          this.hotTableComponent.current.hotInstance.setDataAtRowProp(
                                            parseInt(row, 10),
                                            key,
                                            currentObj[key]
                                          );
                                        }

                                        //更新長度
                                        this.hotTableComponent.current.hotInstance.setDataAtRowProp(
                                          parseInt(row, 10),
                                          'Duration',
                                          currentObj.Duration
                                        );

                                        this.checkFrameSplitErrorArray();
                                      }

                                      if (key === 'SubtitleCaption') {
                                        //更新字幕
                                        //console.log('更新字幕');
                                        this.updateSubTitle_by_row_frame(row);
                                        //console.log('更新字幕 end');
                                        this.hotTableComponent.current.hotInstance.setDataAtRowProp(
                                          parseInt(row, 10),
                                          'Length',
                                          currentObj.Length
                                        );
                                      }

                                      //拖拉更新
                                      this.UpdateSpecificGraySquare_Size(row);
                                      this.UpdateSpecificGraySquare_text(row);

                                      // this.updateInstanceTable_by_Row(row);
                                    }
                                    if (key === 'Position') {
                                      if (parseFloat(newValue) === 1) {
                                        this.arrowUpOrDown(1, this.blue_row);
                                      } else if (
                                        newValue === null ||
                                        newValue === ''
                                      ) {
                                        this.arrowUpOrDown(0, this.blue_row);
                                      }
                                    }
                                  }
                                }
                              );

                              //更新
                              //this.sendsetTableData(this.DataObjArray.getContent());

                              //初始拖拉資料
                              this.DragData = SubTitleUtils.getInitDragData(
                                this.videoFps,
                                this.frameWidth,
                                0,
                                this.DataObjArray.getContent()
                              );

                              //有編輯
                              this.setIsEdit(true);
                            } else {
                              /**
                               * 一次編輯太多
                               * */
                              //主資料更新
                              this.DataObjArray.updateByAllChange(change);
                              //this.sendsetTableData(this.DataObjArray.getContent());

                              //拖拉更新
                              this.saveData_update_EditTable_ITManPlayer_WaveGroup(
                                this.DataObjArray.getContent()
                              );

                              //有編輯
                              this.setIsEdit(true);
                            }
                          }

                          /**
                           * 進行Style檢察
                           * */
                          this.tableRunTargetCheck();
                        }
                      }
                    }}
                    afterSelection={(row, column, row2, column2) => {
                      //console.log(`afterSelection ${row} ${row2}`);
                      this.selectStart = row;
                      this.selectEnd = row2;
                      this.selectStart_col = column;
                      this.selectEnd_col = column2;

                      this.blue_row = row;
                      this.blue_col = column;
                    }}
                    beforePaste={(data, coords) => {}}
                    afterPaste={(data, coords) => {
                      this.PasteEvent = [data, coords];
                    }}
                    beforeCopy={(data, coords) => {
                      // console.log(data);
                      // console.log(coords);
                    }}
                    afterCopy={(data, coords) => {}}
                    afterRedo={async (Event) => {
                      // console.log(Event);
                    }}
                    beforeRedo={async (Event) => {
                      // console.log(Event);
                    }}
                    afterOnCellMouseDown={(event, coords, TD) => {
                      //console.log(event.detail);
                      //  console.log(event);
                      //  console.log(coords);
                      //  console.log(TD);
                    }}
                    beforeKeyDown={(Event) => {
                      //console.log(Event.detail);

                      //目前取得的位置與資料
                      var selection =
                        this.hotTableComponent.current.hotInstance.getSelected();
                      let selectionArray = selection[0];
                      let row = selectionArray[0];
                      let col = selectionArray[1];

                      //lockTC 要鎖delete
                      if (
                        parseFloat(this.projectDetial.isTimecodeLock) === 1 &&
                        Event.keyCode === 46
                      ) {
                        if (parseFloat(col) === 0 || parseFloat(col) === 1) {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();
                          return;
                        }
                      }

                      //console.log("isListening 非輸入中");

                      // if (Event.altKey === true  && Event.key === 'm') {
                      //     console.log("mmmm");
                      //     this.decorativeMusic_from_hotkey(Event);
                      // }

                      // console.log(row);
                      // console.log(col);

                      //回上一步 ctl + z
                      if (
                        (Event.ctrlKey && Event.key === 'z') ||
                        (Event.metaKey && Event.key === 'z')
                      ) {
                      }
                      //
                      //斷行
                      if (Event.altKey && Event.key === 'Enter') {
                        console.log('按下Enter ');

                        Event.preventDefault();
                        Event.stopImmediatePropagation();
                      }

                      if (Event.ctrlKey === true && Event.shiftKey === true) {
                        Event.preventDefault();
                        Event.stopImmediatePropagation();
                      }
                      //
                      //
                      //                     //console.log(`beforeKeyDown ${Event.key}`);
                      if (
                        Event.key === 'Shift' ||
                        Event.key === 'Control' ||
                        Event.key === 'Alt' ||
                        Event.key === 'Meta'
                      ) {
                        Event.preventDefault();
                        Event.stopImmediatePropagation();
                      }
                      //
                      //                     //方向鍵
                      if (this.isEditing === false) {
                        switch (Event.key) {
                          //each of the 4 arrow key codes
                          case 'ArrowDown':
                          case 'ArrowLeft':
                          case 'ArrowUp':
                          case 'ArrowRight':
                            this.hotTableComponent.current.hotInstance.selectCell(
                              selection[0],
                              selection[1]
                            );
                            //設定位置
                            this.currentDataIndex = selectionArray[0];
                            break;
                        }
                      }
                      //
                      //
                      //console.log(`selection row  ${row} col ${col}`);

                      // if (Event.key === 'Enter' ||Event.key === 'Control'||  Event.key === 'p'  ||   Event.key === 'Alt' || Event.key === 'shift'  || Event.key === 'space') {
                      //     Event.preventDefault();
                      //     Event.stopImmediatePropagation();
                      // }

                      if (
                        Event.key === 'Enter' &&
                        Event.altKey === false &&
                        Event.ctrlKey === false
                      ) {
                        //指在 in or out
                        if (col === 0 || col === 1) {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();
                          this.cutTC(row, col);
                        }
                      }

                      /**
                       * Ctrl + Shift 相關
                       * */
                      if (
                        Event.ctrlKey === true &&
                        Event.shiftKey === true &&
                        Event.altKey === false
                      ) {
                        console.log(`Ctrl + Shift  相關 ${Event.key}`);
                        console.log(Event);
 
                        if (Event.key === 'ArrowLeft' ) { 
                          Event.preventDefault();
                          Event.stopImmediatePropagation();  
                          this.player.replay(1/this.videoFps);
                        } else if (Event.key === 'ArrowRight' ) { 
                          Event.preventDefault();
                          Event.stopImmediatePropagation(); 
                          this.player.forward(1/this.videoFps);
                        } else if (Event.key === 'd' || Event.key === 'D') {
                          console.log(`mutile_delete_Row`);
                          Event.preventDefault();
                          Event.stopImmediatePropagation();
                          this.mutile_delete_Row();
                        } else if (Event.key === 's' || Event.key === 'S') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.resize_full('blue');
                        } else if (Event.key === 'm' || Event.key === 'M') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.resize_small('blue');
                        } else if (Event.key === 'm' || Event.key === 'M') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.resize_small('blue');
                        }
                      } else if (
                        /**
                         * Ctrl + Alt 相關
                         * */
                        Event.ctrlKey === true &&
                        Event.altKey === true &&
                        Event.shiftKey === false
                      ) {
                        if (Event.key === 's' || Event.key === 'S') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.resize_full('blue');
                        }
                        if (Event.key === 'm' || Event.key === 'M') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.resize_small('blue');
                        }
                        if (
                          Event.key === 'i' ||
                          Event.key === 'I' ||
                          Event.key === 'Dead'
                        ) {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();
                          this.decorativeLettering_from_hotkey(
                            Event,
                            selectionArray
                          );
                        }
                      } else if (
                        /**
                         * Alt 相關
                         * */
                        Event.altKey === true &&
                        Event.ctrlKey === false &&
                        Event.shiftKey === false
                      ) {
                        if (Event.key === 'ArrowUp') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.arrowUpOrDown(1, this.blue_row);
                          // console.log(`位置上移 ${Event}`);
                        } else if (Event.key === 'ArrowDown') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.arrowUpOrDown(0, this.blue_row);
                          // console.log(`位置下移 ${Event}`);
                        } else if (Event.key === 'ArrowRight') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.arrowUpOrDown(2, this.blue_row);
                          console.log(`文字右移 ${Event}`);
                        } else if (Event.key === 'ArrowLeft') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.arrowUpOrDown(3, this.blue_row);
                          console.log(`文字左移 ${Event}`);
                        } else if (Event.key === 'p' || Event.key === 'P') {
                          this.DoubleClick_from_hotkey(Event, selectionArray);
                        } else if (
                          Event.key === 'i' ||
                          Event.key === 'I' ||
                          Event.key === 'Dead'
                        ) {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.decorativeLettering_from_hotkey(
                            Event,
                            selectionArray
                          );
                        } else if (Event.key === 'm' || Event.key === 'M') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.decorativeMusic_from_hotkey(Event);
                        } else if (Event.code === 'Space') {
                          if (
                            parseInt(
                              localStorage.getItem('PlayFromSelectedRow')
                            ) === 0
                          ) {
                            Event.preventDefault();
                            Event.stopImmediatePropagation();

                            this.ITManPlayer_play(this.blue_row); //控制回傳'
                          }
                        }
                      } else if (Event.ctrlKey || Event.metaKey) {
                        /**
                         * Ctrl 相關
                         * */
                        // console.log(`Ctrl 相關`);
                        // console.log(Event.code);
                        if (Event.code === 'ArrowDown') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          if (
                            parseInt(
                              localStorage.getItem('PlayPauseHoykey')
                            ) === 1
                          ) {
                            if (this.isPlay === true) {
                              this.pause();
                            } else {
                              this.play();
                            }
                          }
                        } else if (Event.key === 'ArrowRight') {
                          if (
                            parseInt(
                              localStorage.getItem('PlayFromSelectedRow')
                            ) === 1
                          ) {
                            Event.preventDefault();
                            Event.stopImmediatePropagation();

                            this.ITManPlayer_play(this.blue_row); //控制回傳'
                          }
                        } else if (Event.key === 'f' || Event.key === 'F') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();
                          console.log(`Find`);
                          this.setState({
                            isShowFindAllViewInput:
                              !this.state.isShowFindAllViewInput,
                          });
                        } else if (Event.key === 'i' || Event.key === 'I') {
                          if (
                            Event.ctrlKey &&
                            Event.altKey === false &&
                            Event.shiftKey === false
                          ) {
                            Event.preventDefault();
                            Event.stopImmediatePropagation();
                            console.log(`新增空白欄位`);
                            this.add_Row_from_ctrl_i(row);
                          }
                        } else if (
                          Event.shiftKey === false &&
                          Event.key === 'd'
                        ) {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();
                          console.log(`刪除 ${selectionArray[0]}`);
                          this.currentDataIndex = selectionArray[0];

                          this.delete_Row(this.blue_row);
                        } else if (Event.code === 'Space') {
                          if (
                            parseInt(
                              localStorage.getItem('PlayFromSelectedRow')
                            ) === 0
                          ) {
                            Event.preventDefault();
                            Event.stopImmediatePropagation();

                            this.ITManPlayer_play(this.blue_row); //控制回傳'
                          }
                        }
                      } else if (
                        /**
                         * Shift 相關
                         * */
                        Event.shiftKey === true &&
                        Event.altKey === false &&
                        Event.ctrlKey === false
                      ) {
                        if (parseFloat(col) === 0 || parseFloat(col) === 1) {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();
                        }

                        if (Event.key === 'ArrowRight') {
                          if (this.isEditing !== true) {
                            //console.log(`退後五秒 ${this.hotTableComponent.current.hotInstance.getColHeader(this.blue_col)}`);
                            this.Jump_Backward_Forward('right'); //控制回傳
                          }
                        } else if (Event.key === 'ArrowLeft') {
                          if (this.isEditing !== true) {
                            // console.log(`往前五秒`);
                            this.Jump_Backward_Forward('left'); //控制回傳
                          }
                        } else if (Event.key === 'ArrowUp') {
                          //
                          if (parseFloat(col) === 0 || parseFloat(col) === 1) {
                            Event.preventDefault();
                            Event.stopImmediatePropagation();

                            this.DragSubtitleWidth(
                              this.blue_row,
                              this.blue_col,
                              'left'
                            );
                          }
                          //
                          // console.log(`this.selectStart ${this.selectStart} ${row } ${ col} `);
                        } else if (Event.key === 'ArrowDown') {
                          //
                          //     console.log(`this.selectStart ${this.selectStart} ${row } ${ col} `);
                          //
                          if (col === 0 || col === 1) {
                            Event.preventDefault();
                            Event.stopImmediatePropagation();

                            this.DragSubtitleWidth(
                              this.blue_row,
                              this.blue_col,
                              'right'
                            );
                          }
                        } else if (Event.key === 'p' || Event.key === 'P') {
                          //this.DoubleClick_from_hotkey(Event, selectionArray);
                        } else if (
                          Event.key === 'i' ||
                          Event.key === 'I' ||
                          Event.key === 'Dead'
                        ) {
                          //當用戶是在focus的狀態要先停止
                          if (Event.shiftKey || Event.altKey || Event.ctrlKey) {
                          } else {
                            this.decorativeLettering_from_hotkey(
                              Event,
                              selectionArray
                            );
                          }
                        } else if (Event.key === 'm' || Event.key === 'M') {
                          //當用戶是在focus的狀態要先停止
                          if (Event.shiftKey || Event.altKey || Event.ctrlKey) {
                          } else {
                            this.decorativeMusic_from_hotkey(Event);
                          }
                        } else if (
                          Event.code === 'Space' ||
                          Event.key === ' '
                        ) {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          if (
                            parseInt(
                              localStorage.getItem('PlayPauseHoykey')
                            ) === 0
                          ) {
                            if (this.isPlay === true) {
                              this.pause();
                            } else {
                              this.play();
                            }
                          }
                        }
                      } else if (
                        /**
                         * Shift + Alt相關
                         * */
                        Event.shiftKey === true &&
                        Event.altKey === true &&
                        Event.ctrlKey === false
                      ) {
                        if (Event.key === 'ArrowUp') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.props.MoveWordToFromNextRow(
                            data,
                            this.findFrameSplitValue,
                            this.videoFps,
                            this.selectStart,
                            'up'
                          );

                          console.log(`第一個字往前移`);
                        } else if (Event.key === 'ArrowDown') {
                          Event.preventDefault();
                          Event.stopImmediatePropagation();

                          this.props.MoveWordToFromNextRow(
                            data,
                            this.findFrameSplitValue,
                            this.videoFps,
                            this.selectStart,
                            'down'
                          );
                          console.log(`最後一個字往後移`);
                        }
                      }
                      this.lastKey = Event.key;
                    }}
                    afterDocumentKeyDown={(Event) => {}}
                    // 滑鼠移動
                    afterOnCellMouseOver={async (Event, CellCoords, TD) => {
                      this.cellCoords_row = CellCoords.row;
                      this.cellCoords_col = CellCoords.col;

                      this.timecode_row = CellCoords.row;

                      let tr = ReactDOM.findDOMNode(TD).parentNode;

                      var rect2 = ReactDOM.findDOMNode(
                        Event.realTarget
                      ).getBoundingClientRect();
                      let leftOffect = rect2.left - 565;
                     // let topOffect = rect2.top - 135;
                      let topOffect = rect2.top - 38;

                      let { colWidths } = this.props.editTable;

                      function checkTarget(age) {
                        return age >= 'Target';
                      }

                      // Target 的 Col
                      let subtitleCol =
                        this.props.editTable.colHeaders.findIndex(checkTarget);

                      // if (isShowSource === true) {
                      //   subtitleCol = 5;
                      // } else {
                      //   subtitleCol = 4;
                      // }

                      // if (this.state.isShowShotChangeList === true) {
                      //   subtitleCol = 6;
                      // }

                      //時間按鈕
                      if (
                        parseInt(CellCoords.col, 10) === 0 ||
                        parseInt(CellCoords.col, 10) === 1
                      ) {
                        if (parseInt(CellCoords.col, 10) === 0) {
                          // 進到 In TC
                          this.setPosition(0, topOffect, leftOffect);

                          this.subtitleViewComponent.setPosition(
                            0,
                            -1000,
                            -1000
                          );
                        } else {
                          // 進到 Out TC
                          this.setPosition(0, topOffect, leftOffect);
                          this.subtitleViewComponent.setPosition(
                            0,
                            -1000,
                            -1000
                          );
                        }
                      } else if (parseInt(CellCoords.col, 10) === subtitleCol) {
                        //位置
                        this.setPosition(0, -1000, -1000);
                        this.subtitleViewComponent.setPosition(
                          1,
                          topOffect,
                          leftOffect
                        );
                      } else if (
                        this.cellCoords_row > -1 &&
                        this.cellCoords_col == 2 &&
                        this.state.isShowShotChangeList === true
                      ) {
                        //shotchange 按鈕
                        // console.log(Event);
                        // console.log(CellCoords);
                        // console.log(TD);
                        //igonre按鈕
                        // this.setPosition(0, topOffect, leftOffect);
                        this.igonreComponent.setPosition(
                          1,
                          topOffect,
                          leftOffect
                        );
                      } else {
                        this.setPosition(0, -1000, -1000);
                        this.subtitleViewComponent.setPosition(1, -1000, -1000);
                      }
                    }}
                  />

                  <div
                    id={'timecodeComponent'}
                    ref={(ref) => (this.timecodeComponent = ref)}
                    style={{
                      top: '-1000px',
                      left: '-1000px',
                      textAlignLast: 'justify',
                      width: '70px',
                      position: 'absolute',
                    }}
                  >
                    <Container className={'p-0 m-0'}>
                      <Row className={'p-0 m-0'}>
                        {readOnly === false ? (
                          <IconWrap width={20}>
                            <Icon
                              color='blue'
                              name='chevron left'
                              size='tiny'
                              // style={{float: 'left'}}
                              onClick={() => {
                                this.chevronEvent('left');
                              }}
                            />
                          </IconWrap>
                        ) : null}

                        <IconWrap width={20}>
                          <Icon
                            color='blue'
                            name='pause'
                            size='tiny'
                            // style={{marginLeft:' 19px'}}
                            onClick={() => {
                              this.timecode_stopClick();
                            }}
                          />
                        </IconWrap>

                        {readOnly === false ? (
                          <IconWrap width={20}>
                            <Icon
                              color='blue'
                              name='chevron right'
                              size='tiny'
                              // style={{float: 'right'}}
                              onClick={() => {
                                this.chevronEvent('right');
                              }}
                            />
                          </IconWrap>
                        ) : null}
                      </Row>
                    </Container>
                  </div>

                  <IgnoreBtnView
                    onRef={(ref) => (this.igonreComponent = ref)}
                    _WaveformView={this}
                    readOnly={readOnly}
                    type={1}
                  />

                  <TimecodeView
                    onRef={(ref) => (this.subtitleViewComponent = ref)}
                    readOnly={readOnly}
                    type={1}
                    playhere={() => {
                      this.ITManPlayer_play(this.timecode_row);
                    }}
                    editTablePause={() => {
                      this.pause();
                    }}
                    add_FN={this.add_FN}
                    add_Row={this.add_Row_from_click}
                    resize_full={() => {
                      this.resize_full('_');
                    }}
                    resize_small={() => {
                      this.resize_small('_');
                    }}
                    delete_Row={() => {
                      this.delete_Row(this.timecode_row);
                    }}
                    //裝飾字樣
                    decorativeLettering={() => {
                      this.cellCoords_row = this.timecode_row;

                      this.decorativeLettering(false);
                    }}
                  />
                </div>
              </small>
            </div>

            <div
              id='ITManPlayer'
              className='float-right'
              style={{
                width: `${this.props.viewOperation.subtitles_Left + 60}px`,
                backgroundColor: '#e7e7e7',
                position: 'absolute',
                top: '5px',
                left: '5px',
                zIndex: 5,
              }}
            >
              <div style={{ position: 'relative' }}>
                <TopControl
                  _WaveformView={this}
                  context={this.props.context}
                  insertSymblo={this.insertSymblo}
                  updatefindFrameSplitValue={this.updatefindFrameSplitValue}
                  updateforwardSeconds={this.updateforwardSeconds}
                />

                <div
                  id={'time_display'}
                  ref={(ref) => (this.time_displayRef = ref)}
                  className='col-12 text-center my-1'
                  style={{
                    fontSize: '9px',
                    width: '320px',
                  }}
                />
                {/*{TimeUtils.convertSecondToTimeString(this.Last_videoCurrentTime,videoFps)} / {TimeUtils.convertSecondToTimeString(videoDuration,videoFps)} */}

                <div
                  className='w-100 position-relative '
                  style={{
                    height: 'fit-content',
                  }}
                  id={' '}
                >
                  <Player
                    id={'PlayerID'}
                    ref={(player) => {
                      this.player = player;
                    }}
                  >
                    {/*<source src={`http://subprpapp.azurewebsites.net/UploadedFiles/${this.props.video['fURL']}`} />*/}
                    {/*<source src={`http://www.thesubpro.com/UploadedFiles/MUPPETSHOWTHE_103-F103_PXY-C_1080P23_133_ENG-ENG_4496935.mov_Pixelogic.EN.mp4`} />*/}

                    <source src={`${UploadedFilesUrl}${this.video['fURL']}`} />
                  </Player>

                  <div
                    id='safearea'
                    style={{
                      left: '23px',
                      right: '23px',
                      top: '25px',
                      bottom: ' 25px',
                    }}
                  />

                  {ccEnable === true ? (
                    <CaptionContainer
                      id='CaptionContainer'
                      textAlign={this.textAlign}
                      top={this.top}
                      bottom={this.bottom}
                    >
                      <div
                        ref={(ref) => (this.captionTextRef = ref)}
                        className='font-1 nowrap  '
                        id='caption-text'
                        style={{
                          display: 'inline-block',
                          paddingLeft: '30px',
                          paddingRight: '30px',
                        }}
                      ></div>
                    </CaptionContainer>
                  ) : null}
                </div>

                <div id='  mt-3' className=' '>
                  <div
                    className='btn-toolbar'
                    role='toolbar'
                    aria-label='Toolbar with button groups'
                  >
                    <div
                      className='btn-group mr-2 btn-group-sm'
                      role='group'
                      aria-label='First group'
                    >
                      <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => {
                          this.changePlaybackRateRate(0.5);
                        }}
                      >
                        0.5X
                      </button>
                      <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => {
                          this.changePlaybackRateRate(0.8);
                        }}
                      >
                        0.8X
                      </button>
                      <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => {
                          this.changePlaybackRateRate(1);
                        }}
                      >
                        1X
                      </button>
                      <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => {
                          this.changePlaybackRateRate(1.2);
                        }}
                      >
                        1.2X
                      </button>
                      <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => {
                          this.changePlaybackRateRate(1.5);
                        }}
                      >
                        1.5X
                      </button>
                      <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => {
                          this.changePlaybackRateRate(2);
                        }}
                      >
                        2X
                      </button>
                    </div>
                    <div
                      className='btn-group btn-group-sm'
                      role='group'
                      aria-label='Third group'
                    >
                      <Icon
                        onClick={() => {
                          this.props.changeCurrentTime(-1);
                        }}
                        name='backward'
                      />
                      <Icon id={'playBtn'} onClick={this.play} name='play' />
                      <Icon
                        id={'pauseBtn'}
                        onClick={this.pause}
                        name='pause'
                        style={{ display: 'none' }}
                      />
                      <Icon
                        onClick={() => {
                          this.props.changeCurrentTime(1);
                        }}
                        name='forward'
                      />

                      <span className='pl-2'>
                        {this.state.isBigFont === true ? (
                          <Button
                            size='mini'
                            onClick={() => {
                              // let CaptionContainer = document.getElementsByClassName('htCenter htBottom');
                              // CaptionContainer.style.fontSize = '11pt';

                              this.setState({ isBigFont: false });
                            }}
                          >
                            CC Medium
                          </Button>
                        ) : (
                          <Button
                            size='mini'
                            basic={true}
                            onClick={() => {
                              // htCenter htBottom

                              // let CaptionContainer = document.getElementsByClassName('htCenter htBottom');
                              // CaptionContainer.style.fontSize = '16pt';
                              this.setState({ isBigFont: true });
                            }}
                          >
                            CC Large
                          </Button>
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: '5px' }}>
                  <input
                    type='checkbox'
                    checked={this.state.isInputLatencyAct}
                    onChange={() => {
                      this.setState({
                        isInputLatencyAct: !this.state.isInputLatencyAct,
                      });
                      localStorage.setItem(
                        'isInputLatencyAct',
                        !this.state.isInputLatencyAct
                      );
                    }}
                  />

                  <span
                    style={{
                      color: `${
                        this.state.isInputLatencyAct === true
                          ? 'black'
                          : '#acacac'
                      }`,
                      paddingLeft: '7px',
                    }}
                  >
                    Input Latency:
                  </span>

                  {/*開啟功能*/}
                  {this.state.isInputLatencyAct === true ? (
                    <select
                      value={this.state.inputLatencyFrameNum}
                      onChange={(event) => {
                        localStorage.setItem(
                          'inputLatencyFrameNum',
                          parseFloat(event.target.value)
                        );
                        this.setState({
                          inputLatencyFrameNum: parseFloat(event.target.value),
                        });
                      }}
                    >
                      <option value='0'>0</option>
                      <option value='1'>1</option>
                      <option value='2'>2</option>
                      <option value='3'>3</option>
                      <option value='4'>4</option>
                      <option value='5'>5</option>
                      <option value='6'>6</option>
                      <option value='7'>7</option>
                      <option value='8'>8</option>
                      <option value='9'>9</option>
                      <option value='10'>10</option>
                    </select>
                  ) : null}
                </div>

                {/*
                            所有的 Find 結果列表
                        */}
                <FindResultGroup _WaveformView={this} />
              </div>
            </div>
          </div>

          <div
            style={{ width: `${window.innerWidth - 60}px`, height: '100px' }}
          >
            <div className='waveform-needle' />
            <div className='waveform-scroll'>
              <div
                id={'WaveformView_view'}
                ref={(ref) => (this.waveform = ref)}
              >
                <div
                  id='waveform-frame'
                  className=' position-absolute'
                  style={{ left: '0px', width: `${waveWidth + 0}px` }}
                >
                  <Draggable
                    axis='x'
                    handle='.handle'
                    defaultPosition={{ x: 0, y: 0 }}
                    bounds={{ left: waveWidth * -1, right: waveWidth }}
                    grid={[1.76, 25]}
                    scale={1}
                    onDrag={this.handleDrag}
                    //onStop={this.handleStop}
                    onStop={() => {
                      DragHandleUtils.handleStop(this);
                    }}
                    position={{ x: 0, y: 0 }}
                  >
                    <div className='position-relative'>
                      <div
                        className='handle position-absolute'
                        style={{
                          top: '0px',
                          left: '0px',
                          width: `${waveWidth + 0}px`,
                          height: '96px',
                        }}
                      >
                        {/*<small>Drag</small>*/}

                        <WaveGroup _WaveformView={this} /> 

                        <div
                          className='mb-1'
                          style={{
                            width: `${waveWidth}px`,
                            marginLeft: `${this.frontDistance}px`,
                            borderBottom: `1px solid darkblue`,
                          }}
                        ></div>
                      </div>

                      <div>
                        <SubtitleContext.Consumer>
                          {(context) => (
                            <div
                              id={'BalloonView'}
                              className={'pt-4'}
                              style={{
                                width: `${waveWidth + 300}px`,
                                height: '54px',
                              }}
                            >
                              {this.DataObjArray.dataArry.map((obj, index) => {
                                if (
                                  index > this.props.currentDataIndex - 30 &&
                                  index < this.props.currentDataIndex + 30
                                ) {
                                }
                                const dataObj = new DataObj(obj);
                                const {
                                  In,
                                  Out,
                                  Memo,
                                  Source,
                                  SubtitleCaption,
                                  Position,
                                } = dataObj;

                                //
                                const eleLeft = dataObj.getDragEleLeft();
                                const eleWidth = dataObj.getDragEleWidth();

                                return (
                                  <div
                                    key={`popup_${index}`}
                                    id={`popup_${index}`}
                                    style={{
                                      left: `${eleLeft}px`,
                                      width: `${eleWidth}px`,
                                    }}
                                    className='popup'
                                    onMouseDown={() => {
                                      // this.style.zIndex = "" + ++this.currentZIndex;
                                    }}
                                  >
                                    <div
                                      className='popup-header'
                                      onDoubleClick={() => {
                                        //灰框點擊兩下
                                        DragHandleUtils.setDoubleClick(
                                          this,
                                          index
                                        );
                                      }}
                                      // ondblclick={()=>{
                                      //     console.log(`setDoubleClick `);
                                      // }}
                                      style={{
                                        height: `${55}px`,
                                      }}
                                      onMouseDown={(e) => {
                                        this.dragMouseDown(e);
                                      }}
                                    >
                                      {SubtitleCaption}
                                    </div>

                                    <div
                                      className='resizer-left'
                                      onMouseDown={this.initDrag}
                                    />
                                    <div
                                      className='resizer-right'
                                      onMouseDown={this.initDrag}
                                    />
                                    <div
                                      className='resizer-bottom'
                                      onMouseDown={this.initDrag}
                                    />
                                    <div
                                      className='resizer-both'
                                      onMouseDown={this.initDrag}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </SubtitleContext.Consumer>
                      </div>
                    </div>
                  </Draggable>
                </div>
              </div>
            </div>
          </div>
          {/* </Hotkeys> */}　
        </React.Fragment>
      </HotkeysHook>
    );
  }
}

WaveformView.propTypes = {};

const mapStateToProps = (state) => ({
  editTable: state.editTable,
  errors: state.errors,
  auth: state.auth,
  viewOperation: state.viewOperation,
  userOperation: state.userOperation,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
});

export default connect(mapStateToProps, {
  set_video_duration,
  // setTableData,
  setTSubType,
  AddTC_FRAME,
  MoveWordToFromNextRow,
  setIsShowFindAllViewReplace,
  showHideFrameList,
  setReadonly,
  setFindAndReplaceSentence,
  addTenRow,
  setEditTableHeight,
  setCellClass,
  set_COLUMNS_TimecodeLock,
  setIsShowFindAllViewInput,
  showHidePositionList,
  AddDetialJsonData,
  jsonData_nolocal,
  get_versionData,
  updateEditTableData,
  setIsEditMode,
  updateFindFrameTargetData,
  updateFindFrameGapTargetData,
  updateShotChangeData,
  updateFindFrameCPSTargetData,
  setPlayerEditingSRTData,
  show_hide_Shot_Change,
  setTableColWidth,
  setTSubType,
})(withRouter(WaveformView));



// WEBPACK FOOTER //
// ./src/components/drogable/WaveformView.js